<template>
    <div class="rtb-trip-create-form-page">
        <Drawer :is-open="isDrawerOpen" :speed="500" @close="closeDrawer">
            <div class="separator my-6 h-2 w-10 rounded-lg bg-gray-300 mx-auto"></div>
            <div class="drawer-content" v-if="drawerContent === 'car_type'">
                <div class="car-lists grid gap-3">
                    <div class="car-single flex justify-between items-center"
                         :class="form.car_type === car.type ? 'active': ''" v-for="car in carLists" :key="car.id"
                         @click="selectCar(car)">
                        <div class="car-image">
                            <img :src="`images/${car.image}`" alt="car rental">
                        </div>
                        <div class="car-info">
                            <p>{{ car.name }}</p>
                            <div class="icon-capacity">
                                <span class="mdi mdi-seat-passenger">{{ car.capacity }} seats</span>
                            </div>
                        </div>
                        <div class="check-select">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"
                                 fill="none">
                                <path
                                    d="M6.75027 15.3152L2.09277 10.6577L4.21527 8.53516L6.75027 11.0777L14.1603 3.66016L16.2828 5.78266L6.75027 15.3152Z"
                                    fill="white"/>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <div class="drawer" v-if="drawerContent === 'pickup_date'">
                <div class="grid gap-3 px-3">
                    <div class="relative w-full">
                        <p class="text-xl font-bold text-center text-black capitalize">
                            ভ্রমণের দিন
                        </p>
                        <div class="separator h-1 w-10 rounded-lg bg-red-200 mx-auto mb-6"></div>
                        <CustomDate
                            @change-date="journeyDateChanged"
                            id="journey_date"
                            :journeyDate="checkTripDateValid() && journeyDate"
                            :date="form.journey_date"
                            :device-type="deviceType"
                        />
                        <span
                            class="text-red-400 block text-xs mt-1"
                            v-text="form.error.get('journey_date')"
                            v-if="form.error.has('journey_date')"
                        ></span>
                    </div>
                    <div class="relative w-full">
                        <p class="text-xl font-bold text-center text-black capitalize mt-3">
                            ভ্রমণের সময়
                        </p>
                        <div class="separator h-1 w-10 rounded-lg bg-red-200 mx-auto mb-6"></div>

                        <CustomTime v-if="form.journey_date" :timeLists="timeListItems" :device-type="deviceType"
                                    @change-time="journeyTimeChanged"/>

                        <span
                            class="text-red-400 block text-xs mt-1"
                            v-text="form.error.get('journey_date')"
                            v-if="form.error.has('journey_date')"
                        ></span>
                    </div>
                </div>
                <div @click="closeDrawer()"
                     class="close-drawer mt-5 cursor-pointer flex items-center justify-center gap-3 h-12 rounded-xl bg-red-600 text-white font-semibold w-40 mx-auto py-3">
                    <button>নিশ্চিত করুন</button>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                        <g clip-path="url(#clip0_620_741)">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M21.546 5.61155C21.8272 5.89285 21.9852 6.27431 21.9852 6.67205C21.9852 7.0698 21.8272 7.45126 21.546 7.73255L10.303 18.9756C10.1544 19.1242 9.97805 19.2421 9.7839 19.3225C9.58976 19.4029 9.38167 19.4443 9.17153 19.4443C8.96138 19.4443 8.75329 19.4029 8.55915 19.3225C8.365 19.2421 8.1886 19.1242 8.04003 18.9756L2.45403 13.3906C2.31076 13.2522 2.19649 13.0867 2.11787 12.9037C2.03926 12.7207 1.99788 12.5238 1.99615 12.3247C1.99442 12.1255 2.03237 11.928 2.10779 11.7436C2.18322 11.5593 2.29459 11.3918 2.43543 11.251C2.57627 11.1101 2.74375 10.9987 2.92809 10.9233C3.11244 10.8479 3.30996 10.8099 3.50913 10.8117C3.7083 10.8134 3.90513 10.8548 4.08813 10.9334C4.27114 11.012 4.43666 11.1263 4.57503 11.2696L9.17103 15.8656L19.424 5.61155C19.5633 5.47216 19.7287 5.36159 19.9108 5.28615C20.0928 5.21071 20.288 5.17188 20.485 5.17188C20.6821 5.17188 20.8772 5.21071 21.0593 5.28615C21.2413 5.36159 21.4067 5.47216 21.546 5.61155Z"
                                  fill="white"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_620_741">
                                <rect width="24" height="24" fill="white" transform="translate(0 0.5)"/>
                            </clipPath>
                        </defs>
                    </svg>
                </div>
            </div>
            <div class="drawer" v-if="drawerContent === 'return_date'">
                <div class="grid gap-3">
                    <div class="relative w-full">
                        <label for="return_date" class="text-sm text-gray-600 capitalize">
                            {{ $t("triCreateForm.returnDate") }}
                        </label>
                        <CustomDate
                            class="tracking-widest text-black rounded bg-gray-100 mb-4 w-full border border-gray-200 text-xs"
                            @change-date="returnDateChanged"
                            style="word-spacing: 10px"
                            id="return_date"
                            :returnDate="checkTripDateValid() && returnDate"
                            :device-type="deviceType"
                            :date="form.return_date"
                        />
                        <span
                            class="text-red-400 block text-xs mt-1"
                            v-text="form.error.get('return_date')"
                            v-if="form.error.has('return_date')"
                        ></span>
                    </div>
                    <div class="relative w-full">
                        <CustomTime v-if="form.return_date" :timeLists="timeListItems" @change-time="returnTimeChanged"
                                    :device-type="deviceType"/>
                        <span
                            class="text-red-400 block text-xs mt-1"
                            v-text="form.error.get('return_date')"
                            v-if="form.error.has('return_date')"
                        ></span>
                    </div>
                </div>
                <div @click="closeDrawer()"
                     class="close-drawer mt-5 cursor-pointer flex items-center justify-center gap-3 h-12 rounded-xl bg-red-600 text-white font-semibold w-40 mx-auto py-3">
                    <button>নিশ্চিত করুন</button>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                        <g clip-path="url(#clip0_620_741)">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M21.546 5.61155C21.8272 5.89285 21.9852 6.27431 21.9852 6.67205C21.9852 7.0698 21.8272 7.45126 21.546 7.73255L10.303 18.9756C10.1544 19.1242 9.97805 19.2421 9.7839 19.3225C9.58976 19.4029 9.38167 19.4443 9.17153 19.4443C8.96138 19.4443 8.75329 19.4029 8.55915 19.3225C8.365 19.2421 8.1886 19.1242 8.04003 18.9756L2.45403 13.3906C2.31076 13.2522 2.19649 13.0867 2.11787 12.9037C2.03926 12.7207 1.99788 12.5238 1.99615 12.3247C1.99442 12.1255 2.03237 11.928 2.10779 11.7436C2.18322 11.5593 2.29459 11.3918 2.43543 11.251C2.57627 11.1101 2.74375 10.9987 2.92809 10.9233C3.11244 10.8479 3.30996 10.8099 3.50913 10.8117C3.7083 10.8134 3.90513 10.8548 4.08813 10.9334C4.27114 11.012 4.43666 11.1263 4.57503 11.2696L9.17103 15.8656L19.424 5.61155C19.5633 5.47216 19.7287 5.36159 19.9108 5.28615C20.0928 5.21071 20.288 5.17188 20.485 5.17188C20.6821 5.17188 20.8772 5.21071 21.0593 5.28615C21.2413 5.36159 21.4067 5.47216 21.546 5.61155Z"
                                  fill="white"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_620_741">
                                <rect width="24" height="24" fill="white" transform="translate(0 0.5)"/>
                            </clipPath>
                        </defs>
                    </svg>
                </div>
            </div>
        </Drawer>
        <div>
            <div v-if="!secondPage" class="flex my-2">
                <div class="flex-grow">
                    <h2 class="text-gray-700 capitalize text-lg text-center font-semibold w-full mb-5">
                        {{ $t("card.tripCreate") }}
                    </h2>
                </div>
                <i
                    @click="setDialog(false)"
                    v-if="type !== 'individual-page'"
                    class="mdi mdi-close cursor-pointer hover:text-primary text-gray-400 w-6 h-6 p-1 rounded-full bg-red-50 leading-none"
                ></i>
            </div>

            <form
                @submit.prevent="submit"
                @keydown="form.error.clear($event.target.name)"
                class=""
            >
                <div v-show="!secondPage">
                    <div class="input-container">
                        <div class="flex flex-row">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                <g clip-path="url(#clip0_2693_56341)">
                                    <path d="M6.46875 14.8C5.15295 14.8 4.07921 14.6003 3.24753 14.2008C2.41584 13.8014 2 13.2861 2 12.655C2 12.2379 2.17999 11.8745 2.53997 11.5646C2.89996 11.2548 3.39648 11.0105 4.02956 10.8317L4.45781 12.1902C4.24679 12.2498 4.05438 12.3244 3.8806 12.414C3.70681 12.5037 3.58889 12.584 3.52682 12.655C3.68819 12.8457 4.06059 13.0125 4.64401 13.1555C5.22743 13.2985 5.83568 13.37 6.46875 13.37C7.10182 13.37 7.7133 13.2985 8.30317 13.1555C8.89305 13.0125 9.26842 12.8457 9.4293 12.655C9.36723 12.5835 9.24931 12.5029 9.07552 12.4133C8.90174 12.3237 8.70933 12.2494 8.49831 12.1902L8.92656 10.8317C9.55964 11.0105 10.0532 11.2548 10.4072 11.5646C10.7612 11.8745 10.938 12.2379 10.9375 12.655C10.9375 13.2866 10.5217 13.8021 9.68997 14.2015C8.85829 14.601 7.78455 14.8005 6.46875 14.8ZM6.46875 12.655C6.3322 12.655 6.20807 12.6161 6.09635 12.5385C5.98464 12.4608 5.90395 12.3566 5.8543 12.226C5.56879 11.3799 5.20881 10.6709 4.77435 10.0989C4.33989 9.52687 3.91784 8.97871 3.5082 8.45437C3.11098 7.93004 2.76664 7.38783 2.47518 6.82775C2.18372 6.26767 2.03774 5.5765 2.03724 4.75425C2.03724 3.56258 2.46549 2.55562 3.32201 1.73337C4.17852 0.911125 5.22743 0.5 6.46875 0.5C7.71007 0.5 8.75898 0.911125 9.61549 1.73337C10.472 2.55562 10.9003 3.56258 10.9003 4.75425C10.9003 5.5765 10.7575 6.26767 10.472 6.82775C10.1865 7.38783 9.83893 7.93004 9.4293 8.45437C9.03207 8.97871 8.61325 9.52687 8.17283 10.0989C7.73241 10.6709 7.3692 11.3799 7.0832 12.226C7.03355 12.3571 6.95286 12.4615 6.84115 12.5392C6.72943 12.6169 6.60529 12.6555 6.46875 12.655ZM6.46875 6.27362C6.90321 6.27362 7.27561 6.12467 7.58594 5.82675C7.89627 5.52883 8.05143 5.17133 8.05143 4.75425C8.05143 4.33717 7.89627 3.97967 7.58594 3.68175C7.27561 3.38383 6.90321 3.23487 6.46875 3.23487C6.03429 3.23487 5.66189 3.38383 5.35156 3.68175C5.04123 3.97967 4.88607 4.33717 4.88607 4.75425C4.88607 5.17133 5.04123 5.52883 5.35156 5.82675C5.66189 6.12467 6.03429 6.27362 6.46875 6.27362Z" fill="#BBC6D0"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_2693_56341">
                                        <rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
                                    </clipPath>
                                </defs>
                            </svg>
                            <p class="text-sm ml-2 font-notoSans text-black font-semibold">যাত্রা শুরুর স্থান</p>
                        </div>
                        <div class="did-floating-label-content relative">
                            <vue-google-autocomplete
                                ref="address"
                                id="pickup"
                                types="establishment"
                                classname="did-floating-input"
                                :class="error.pickup === true ? 'errorClass' : ''"
                                placeholder="যাত্রা শুরুর স্থান নির্বাচন করুন"
                                v-on:placechanged="getAddressData"
                                :fields="['address_components', 'geometry', 'name']"
                                country="BD"
                                @focus="showPickupRecentSearches = true"
                                @blur="showPickupRecentSearches = false"
                            >
                            </vue-google-autocomplete>
                            <svg v-if="isPickupSelected" @click="clearInput('pickup')"
                                 class="absolute top-2 right-2 cursor-pointer" xmlns="http://www.w3.org/2000/svg"
                                 width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M12 4C7.54286 4 4 7.54286 4 12C4 16.4571 7.54286 20 12 20C16.4571 20 20 16.4571 20 12C20 7.54286 16.4571 4 12 4ZM12 18.8571C8.22857 18.8571 5.14286 15.7714 5.14286 12C5.14286 8.22857 8.22857 5.14286 12 5.14286C15.7714 5.14286 18.8571 8.22857 18.8571 12C18.8571 15.7714 15.7714 18.8571 12 18.8571Z"
                                    fill="#BBC6D0"/>
                                <path
                                    d="M15.0857 16L12 12.9143L8.91429 16L8 15.0857L11.0857 12L8 8.91429L8.91429 8L12 11.0857L15.0857 8L16 8.91429L12.9143 12L16 15.0857L15.0857 16Z"
                                    fill="#BBC6D0"/>
                            </svg>
                            <span
                                class="text-red-500 block text-sm mt-1"
                                v-if="error.pickup"
                                v-text="error.pickup_message"
                            ></span>
                            <span
                                class="text-red-400 block text-xs mt-1"
                                v-text="form.error.get('pickup')"
                                v-if="form.error.has('pickup')"
                            ></span>
                        </div>
                    </div>

                    <div class="width-set flex flex-row-reverse cursor-pointer" @click="viaShow = !viaShow">
                        <span v-if="!viaShow" class="mdi mdi-plus-circle mdi-dark mdi-18px"></span>
                        <span v-else class="mdi mdi-close-circle mdi-dark mdi-18px"></span>
                    </div>

                    <div v-if="viaShow" class="input-container">
                        <div class="did-floating-label-content relative">
                            <div class="flex flex-row">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                    <circle cx="8" cy="8.5" r="4.5" stroke="#9D9D9D"/>
                                </svg>
                                <p class="text-sm ml-2 font-notoSans text-black font-semibold">ভায়া লোকেশন</p>
                            </div>
                            <vue-google-autocomplete
                                ref="address3"
                                id="via"
                                types="establishment"
                                classname="did-floating-input"
                                :class="error.via === true ? 'errorClass' : ''"
                                placeholder="ভায়া লোকেশন নির্বাচন করুন"
                                v-on:placechanged="getAddressData"
                                :fields="['address_components', 'geometry', 'name']"
                                country="BD"
                                @focus="showPickupRecentSearches = true"
                                @blur="showPickupRecentSearches = false"
                            >
                            </vue-google-autocomplete>
                            <svg v-if="isViaSelected" @click="clearInput('via')"
                                 class="absolute top-7 right-2 cursor-pointer" xmlns="http://www.w3.org/2000/svg"
                                 width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M12 4C7.54286 4 4 7.54286 4 12C4 16.4571 7.54286 20 12 20C16.4571 20 20 16.4571 20 12C20 7.54286 16.4571 4 12 4ZM12 18.8571C8.22857 18.8571 5.14286 15.7714 5.14286 12C5.14286 8.22857 8.22857 5.14286 12 5.14286C15.7714 5.14286 18.8571 8.22857 18.8571 12C18.8571 15.7714 15.7714 18.8571 12 18.8571Z"
                                    fill="#BBC6D0"/>
                                <path
                                    d="M15.0857 16L12 12.9143L8.91429 16L8 15.0857L11.0857 12L8 8.91429L8.91429 8L12 11.0857L15.0857 8L16 8.91429L12.9143 12L16 15.0857L15.0857 16Z"
                                    fill="#BBC6D0"/>
                            </svg>
                            <span
                                class="text-red-500 block text-sm mt-1 ml-10"
                                v-if="error.via"
                            >ভায়া লোকেশন নির্বাচন করুন</span>
                            <span
                                class="text-red-400 block text-xs mt-1"
                                v-text="form.error.get('via')"
                                v-if="form.error.has('via')"
                            ></span>
                        </div>
                    </div>

                    <div class="input-container">
                        <div class="did-floating-label-content relative">
                            <div class="flex flex-row">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                    <path d="M2.42773 1.64307V15.3574V1.64307ZM11.5706 9.02768H2.42773V1.64307H11.5706L8.52297 5.33537L11.5706 9.02768Z" fill="#BBC6D0"/>
                                    <path d="M2.42773 1.64307V15.3574M2.42773 1.64307V9.02768H11.5706L8.52297 5.33537L11.5706 1.64307H2.42773Z" stroke="#BBC6D0" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <p class="text-sm ml-2 font-notoSans text-black font-semibold">গন্তব্য স্থান</p>
                            </div>
                            <vue-google-autocomplete
                                ref="address1"
                                id="destination"
                                types="establishment"
                                classname="did-floating-input"
                                :class="error.pickup === true ? 'errorClass' : ''"
                                placeholder="গন্তব্য স্থান নির্বাচন করুন"
                                v-on:placechanged="getAddressData"
                                :fields="['address_components', 'geometry', 'name']"
                                country="BD"
                                @focus="showPickupRecentSearches = true"
                                @blur="showPickupRecentSearches = false"
                            >
                            </vue-google-autocomplete>
                            <svg v-if="isDestinationSelected" @click="clearInput('destination')"
                                 class="absolute top-7 right-2 cursor-pointer" xmlns="http://www.w3.org/2000/svg"
                                 width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M12 4C7.54286 4 4 7.54286 4 12C4 16.4571 7.54286 20 12 20C16.4571 20 20 16.4571 20 12C20 7.54286 16.4571 4 12 4ZM12 18.8571C8.22857 18.8571 5.14286 15.7714 5.14286 12C5.14286 8.22857 8.22857 5.14286 12 5.14286C15.7714 5.14286 18.8571 8.22857 18.8571 12C18.8571 15.7714 15.7714 18.8571 12 18.8571Z"
                                    fill="#BBC6D0"/>
                                <path
                                    d="M15.0857 16L12 12.9143L8.91429 16L8 15.0857L11.0857 12L8 8.91429L8.91429 8L12 11.0857L15.0857 8L16 8.91429L12.9143 12L16 15.0857L15.0857 16Z"
                                    fill="#BBC6D0"/>
                            </svg>
                            <span
                                class="text-red-500 block text-sm mt-1 ml-10"
                                v-if="error.destination"
                                v-text="error.destination_message"
                            ></span>
                            <span
                                class="text-red-400 block text-xs mt-1"
                                v-text="form.error.get('destination')"
                                v-if="form.error.has('destination')"
                            ></span>
                        </div>
                    </div>

                    <div class="width-set">
                        <div class="text-sm font-semibold capitalize mt-6">
                            <p>{{ $t("triCreateForm.type") }}</p>
                        </div>
                        <div class="flex flex-row justify-between gap-1">
                            <div class="trip-type flex flex-row justify-between w-2/3" :class="form.type === 'oneway'? 'active': ''"
                                 @click="form.type = 'oneway'">
                                <div class="flex flex-row items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                        <path d="M13.8738 4.50588C11.5444 4.47282 8.30851 4.52115 7.6423 6.25099L6.00547 9.96352C5.93287 9.88325 5.83766 9.82514 5.73147 9.7963L5.07246 9.61709C4.99999 9.59723 4.92418 9.5914 4.84938 9.59993C4.77458 9.60846 4.70226 9.63119 4.63657 9.66681C4.57088 9.70243 4.51311 9.75024 4.46658 9.80749C4.42006 9.86475 4.38569 9.93032 4.36545 10.0004L4.02164 11.1805C4.00113 11.2505 3.99512 11.3238 4.00396 11.396C4.0128 11.4683 4.03632 11.5382 4.07317 11.6017C4.11001 11.6652 4.15947 11.721 4.21868 11.7659C4.2779 11.8109 4.34572 11.8441 4.41825 11.8637L5.07746 12.0431C5.09946 12.0489 5.12146 12.0508 5.14346 12.0543C5.01746 12.3578 4.93906 12.6915 4.93906 12.89V17.2049C4.93906 17.4261 5.03506 17.5286 5.18746 17.5765V18.726C5.18722 18.828 5.20784 18.9291 5.24813 19.0234C5.28842 19.1178 5.34759 19.2035 5.42224 19.2756C5.4969 19.3478 5.58556 19.405 5.68314 19.4439C5.78072 19.4829 5.8853 19.5028 5.99087 19.5026H8.1463C8.25188 19.5028 8.35646 19.4829 8.45404 19.4439C8.55162 19.405 8.64028 19.3478 8.71493 19.2756C8.78958 19.2035 8.84875 19.1178 8.88904 19.0234C8.92933 18.9291 8.94995 18.828 8.94972 18.726V17.6187H19.0505V18.726C19.0503 18.828 19.0709 18.9291 19.1113 19.0234C19.1516 19.1177 19.2108 19.2034 19.2854 19.2756C19.3601 19.3477 19.4488 19.4049 19.5463 19.4439C19.6439 19.4828 19.7485 19.5028 19.8541 19.5026H22.0091C22.1147 19.5028 22.2193 19.4829 22.3169 19.4439C22.4145 19.405 22.5032 19.3478 22.5779 19.2756C22.6526 19.2035 22.7118 19.1178 22.7521 19.0235C22.7924 18.9292 22.8131 18.8281 22.8129 18.726V17.5767C22.9655 17.5288 23.0609 17.4263 23.0609 17.2051V12.8902C23.0609 12.6917 22.9823 12.358 22.8565 12.0545C22.8785 12.0512 22.9005 12.0493 22.9225 12.0433L23.5819 11.8639C23.6544 11.8443 23.7222 11.8111 23.7814 11.7661C23.8406 11.7211 23.8901 11.6653 23.9269 11.6018C23.9637 11.5384 23.9872 11.4685 23.9961 11.3962C24.0049 11.3239 23.9989 11.2507 23.9783 11.1807L23.6349 10.0006C23.6147 9.93051 23.5803 9.86493 23.5337 9.80767C23.4872 9.75042 23.4294 9.70261 23.3637 9.66699C23.298 9.63137 23.2257 9.60865 23.1508 9.60012C23.076 9.59159 23.0002 9.59742 22.9277 9.61729L22.2687 9.79649C22.1625 9.82546 22.0673 9.88354 21.9945 9.96372L20.3577 6.25118C19.6437 4.49505 16.2032 4.53894 13.8738 4.50588ZM20.5453 10.198C20.5841 10.3094 20.4681 10.3836 20.3467 10.3904C20.3467 10.3904 19.9499 10.4229 19.4027 10.4656C18.9863 9.52526 18.0187 8.86256 16.8976 8.86256C15.6674 8.86256 14.623 9.66098 14.288 10.7482C14.1952 10.7494 14.0874 10.7532 14.0012 10.7532C11.8818 10.7532 7.6533 10.3904 7.6533 10.3904C7.53209 10.3834 7.41589 10.3092 7.45469 10.198C9.08312 5.3996 9.13172 5.76034 13.91 5.81079C18.6881 5.86106 18.7159 5.5183 20.5453 10.198ZM16.8976 9.76943C17.1926 9.76844 17.4833 9.83845 17.7433 9.97315C18.0033 10.1078 18.2246 10.303 18.3871 10.541C17.43 10.6096 16.3286 10.6798 15.3022 10.7206C15.4499 10.434 15.6776 10.193 15.9595 10.025C16.2414 9.85688 16.5664 9.76837 16.8976 9.76943ZM5.88127 11.3266C5.89567 11.3473 5.90967 11.368 5.92567 11.3879H5.86367L5.88127 11.3266ZM6.94009 12.5318C7.35929 12.5252 9.60973 13.2573 9.60973 13.2573C9.89073 13.3339 10.1381 13.8473 10.1367 14.1296C10.1325 15.0802 7.5949 14.7502 6.56468 14.754C6.49545 14.7541 6.42688 14.7411 6.36289 14.7155C6.29891 14.69 6.24077 14.6525 6.19181 14.6052C6.14285 14.5579 6.10403 14.5017 6.07758 14.4398C6.05113 14.378 6.03757 14.3117 6.03767 14.2448V13.0414C6.03767 12.7591 6.52088 12.5388 6.94009 12.5318ZM21.0599 12.5318C21.4791 12.5386 21.9623 12.7591 21.9623 13.0414V14.2448C21.9624 14.3117 21.9489 14.378 21.9225 14.4399C21.896 14.5018 21.8572 14.558 21.8083 14.6053C21.7593 14.6526 21.7011 14.6901 21.6371 14.7157C21.5731 14.7413 21.5046 14.7543 21.4353 14.7542C20.4053 14.7503 17.8675 15.0802 17.8633 14.1296C17.8619 13.8473 18.1093 13.3339 18.3903 13.2573C18.3903 13.2573 20.6407 12.5252 21.0599 12.5318Z" fill="#9D9D9D"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.0672 26.2642C15.2235 26.4152 15.4354 26.5 15.6564 26.5C15.8774 26.5 16.0893 26.4152 16.2456 26.2642L18.7456 23.8476C18.8252 23.7733 18.8887 23.6845 18.9324 23.5862C18.976 23.4879 18.999 23.3822 19 23.2753C19.001 23.1683 18.9799 23.0622 18.938 22.9632C18.8961 22.8642 18.8342 22.7743 18.7559 22.6987C18.6777 22.623 18.5847 22.5632 18.4822 22.5227C18.3798 22.4822 18.2701 22.4619 18.1594 22.4628C18.0488 22.4637 17.9394 22.4859 17.8378 22.5281C17.7361 22.5704 17.6441 22.6317 17.5673 22.7087L15.0672 25.1252C14.911 25.2762 14.8232 25.4811 14.8232 25.6947C14.8232 25.9083 14.911 26.1131 15.0672 26.2642Z" fill="#9D9D9D"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.0673 20.2922C14.911 20.4433 14.8233 20.6481 14.8233 20.8617C14.8233 21.0753 14.911 21.2802 15.0673 21.4312L17.5673 23.8477C17.7245 23.9945 17.935 24.0757 18.1535 24.0738C18.372 24.072 18.581 23.9873 18.7355 23.8379C18.89 23.6886 18.9776 23.4865 18.9795 23.2753C18.9814 23.0641 18.8974 22.8607 18.7456 22.7088L16.2456 20.2922C16.0893 20.1412 15.8774 20.0564 15.6564 20.0564C15.4355 20.0564 15.2235 20.1412 15.0673 20.2922Z" fill="#9D9D9D"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.99987 23.278C8.99987 23.4916 9.08767 23.6965 9.24395 23.8476C9.40024 23.9986 9.6122 24.0835 9.83322 24.0835H16.5C16.721 24.0835 16.933 23.9986 17.0892 23.8476C17.2455 23.6965 17.3333 23.4916 17.3333 23.278C17.3333 23.0644 17.2455 22.8595 17.0892 22.7084C16.933 22.5573 16.721 22.4725 16.5 22.4725H9.83322C9.6122 22.4725 9.40024 22.5573 9.24395 22.7084C9.08767 22.8595 8.99987 23.0644 8.99987 23.278Z" fill="#9D9D9D"/>
                                    </svg>
                                    <p class="sm:text-sm text-xs font-semibold">ওয়ান ওয়ে</p>
                                </div>
                                <div class="svg w-1/3">

                                </div>
                            </div>
                            <div class="trip-type flex flex-row justify-between w-2/3" :class="form.type === 'round'? 'active': ''"
                                 @click="form.type = 'round'">
                                <div class="flex flex-row items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="28" viewBox="0 0 35 28" fill="none">
                                        <path d="M9.94882 6.00604C7.60168 5.97205 4.34125 6.02176 3.66998 7.80071L2.02071 11.6187C1.94756 11.5361 1.85163 11.4763 1.74463 11.4467L1.08061 11.2624C1.00759 11.242 0.931208 11.236 0.855838 11.2447C0.780467 11.2535 0.707595 11.2769 0.641405 11.3135C0.575214 11.3502 0.517008 11.3993 0.470129 11.4582C0.423249 11.5171 0.388619 11.5845 0.368226 11.6566L0.0218072 12.8702C0.00113417 12.9422 -0.00492197 13.0175 0.00398692 13.0918C0.0128958 13.1662 0.0365941 13.238 0.0737222 13.3033C0.11085 13.3686 0.160678 13.426 0.220346 13.4722C0.280013 13.5185 0.348347 13.5526 0.421427 13.5728L1.08565 13.7573C1.10781 13.7632 1.12998 13.7652 1.15215 13.7688C1.02519 14.0809 0.946193 14.4241 0.946193 14.6282V19.0657C0.946193 19.2931 1.04292 19.3985 1.19648 19.4478V20.6299C1.19624 20.7349 1.21702 20.8388 1.25762 20.9358C1.29822 21.0328 1.35784 21.121 1.43305 21.1952C1.50827 21.2694 1.5976 21.3282 1.69593 21.3683C1.79425 21.4083 1.89963 21.4288 2.006 21.4286H4.17781C4.28419 21.4288 4.38955 21.4083 4.48787 21.3683C4.58619 21.3282 4.67553 21.2694 4.75075 21.1952C4.82597 21.121 4.88558 21.0328 4.92618 20.9358C4.96678 20.8388 4.98755 20.7349 4.98732 20.6299V19.4912H15.1648V20.6299C15.1646 20.7349 15.1855 20.8388 15.2261 20.9358C15.2667 21.0328 15.3264 21.1209 15.4016 21.1951C15.4768 21.2693 15.5662 21.3281 15.6645 21.3682C15.7628 21.4083 15.8682 21.4288 15.9745 21.4286H18.1459C18.2523 21.4288 18.3577 21.4083 18.4561 21.3683C18.5544 21.3282 18.6438 21.2694 18.719 21.1952C18.7943 21.121 18.8539 21.0329 18.8946 20.9359C18.9352 20.8389 18.956 20.7349 18.9558 20.6299V19.448C19.1096 19.3987 19.2057 19.2933 19.2057 19.0659V14.6284C19.2057 14.4243 19.1265 14.0811 18.9998 13.769C19.0219 13.7656 19.0441 13.7636 19.0663 13.7575L19.7307 13.573C19.8038 13.5528 19.8721 13.5186 19.9317 13.4724C19.9914 13.4262 20.0412 13.3687 20.0783 13.3035C20.1154 13.2382 20.1391 13.1663 20.148 13.092C20.1569 13.0177 20.1508 12.9424 20.1301 12.8704L19.7841 11.6568C19.7637 11.5847 19.729 11.5173 19.6821 11.4584C19.6352 11.3995 19.577 11.3503 19.5108 11.3137C19.4446 11.2771 19.3717 11.2537 19.2963 11.2449C19.2209 11.2362 19.1446 11.2422 19.0715 11.2626L18.4075 11.4469C18.3005 11.4767 18.2045 11.5364 18.1312 11.6189L16.482 7.80091C15.7625 5.99492 12.296 6.04004 9.94882 6.00604ZM16.671 11.8598C16.7101 11.9743 16.5932 12.0507 16.4709 12.0576C16.4709 12.0576 16.0711 12.091 15.5197 12.135C15.1001 11.1679 14.1252 10.4864 12.9956 10.4864C11.7561 10.4864 10.7037 11.3075 10.3662 12.4256C10.2727 12.4268 10.164 12.4308 10.0772 12.4308C7.94165 12.4308 3.68106 12.0576 3.68106 12.0576C3.55894 12.0505 3.44185 11.9741 3.48095 11.8598C5.12174 6.92513 5.17071 7.29614 9.98529 7.34803C14.7997 7.39972 14.8277 7.0472 16.671 11.8598ZM12.9956 11.4191C13.2929 11.418 13.5857 11.49 13.8477 11.6286C14.1097 11.7671 14.3326 11.9677 14.4964 12.2125C13.5321 12.2831 12.4223 12.3552 11.3881 12.3972C11.5369 12.1025 11.7663 11.8547 12.0504 11.6818C12.3345 11.509 12.6619 11.418 12.9956 11.4191ZM1.89557 13.0205C1.91008 13.0417 1.92418 13.063 1.9403 13.0835H1.87783L1.89557 13.0205ZM2.96243 14.2598C3.38482 14.2531 5.65234 15.006 5.65234 15.006C5.93548 15.0847 6.18477 15.6128 6.18336 15.903C6.17913 16.8806 3.62221 16.5412 2.58417 16.5452C2.51441 16.5453 2.44532 16.5319 2.38085 16.5056C2.31638 16.4793 2.25779 16.4408 2.20846 16.3921C2.15913 16.3435 2.12002 16.2857 2.09336 16.2221C2.06671 16.1585 2.05305 16.0903 2.05316 16.0215V14.7839C2.05316 14.4936 2.54003 14.267 2.96243 14.2598ZM17.1895 14.2598C17.6119 14.2668 18.0988 14.4936 18.0988 14.7839V16.0215C18.0989 16.0903 18.0853 16.1585 18.0586 16.2221C18.032 16.2858 17.9929 16.3436 17.9435 16.3922C17.8942 16.4409 17.8356 16.4795 17.7711 16.5058C17.7066 16.532 17.6375 16.5455 17.5678 16.5454C16.5299 16.5414 13.9728 16.8806 13.9686 15.903C13.9672 15.6128 14.2165 15.0847 14.4996 15.006C14.4996 15.006 16.7671 14.2531 17.1895 14.2598Z" fill="#9D9D9D"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M28.5288 12.2303C28.3714 12.075 28.2829 11.8643 28.2829 11.6447C28.2829 11.425 28.3714 11.2144 28.5288 11.059L31.0478 8.57388C31.1253 8.49476 31.2179 8.43165 31.3204 8.38824C31.4228 8.34483 31.533 8.32197 31.6445 8.32102C31.756 8.32006 31.8666 8.34102 31.9697 8.38267C32.0729 8.42432 32.1667 8.48583 32.2455 8.56361C32.3244 8.64139 32.3867 8.73388 32.4289 8.83569C32.4712 8.93749 32.4924 9.04657 32.4914 9.15656C32.4905 9.26655 32.4673 9.37525 32.4233 9.47632C32.3793 9.57738 32.3153 9.66879 32.2351 9.74521L29.7161 12.2303C29.5586 12.3856 29.3451 12.4729 29.1224 12.4729C28.8998 12.4729 28.6862 12.3856 28.5288 12.2303Z" fill="#9D9D9D"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M34.7542 12.2303C34.5967 12.3856 34.3832 12.4729 34.1605 12.4729C33.9379 12.4729 33.7243 12.3856 33.5668 12.2303L31.0478 9.74521C30.8949 9.58897 30.8102 9.37972 30.8121 9.16252C30.8141 8.94533 30.9024 8.73756 31.058 8.58397C31.2137 8.43038 31.4243 8.34326 31.6445 8.34138C31.8647 8.33949 32.0768 8.42298 32.2351 8.57388L34.7542 11.059C34.9116 11.2144 35 11.425 35 11.6447C35 11.8643 34.9116 12.075 34.7542 12.2303Z" fill="#9D9D9D"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M31.6415 9.98792C31.8642 9.98792 32.0777 10.0752 32.2352 10.2305C32.3927 10.3859 32.4811 10.5966 32.4811 10.8163V17.4433C32.4811 17.663 32.3927 17.8737 32.2352 18.0291C32.0777 18.1844 31.8642 18.2717 31.6415 18.2717C31.4188 18.2717 31.2052 18.1844 31.0477 18.0291C30.8903 17.8737 30.8018 17.663 30.8018 17.4433V10.8163C30.8018 10.5966 30.8903 10.3859 31.0477 10.2305C31.2052 10.0752 31.4188 9.98792 31.6415 9.98792ZM28.0367 16.0293C28.1941 16.1846 28.2826 16.3953 28.2826 16.6149C28.2826 16.8346 28.1941 17.0453 28.0367 17.2006L25.5177 19.6857C25.3593 19.8366 25.1472 19.9201 24.9271 19.9182C24.7069 19.9164 24.4963 19.8292 24.3406 19.6756C24.1849 19.5221 24.0966 19.3143 24.0947 19.0971C24.0928 18.8799 24.1774 18.6706 24.3304 18.5144L26.8494 16.0293C27.0069 15.874 27.2204 15.7867 27.4431 15.7867C27.6657 15.7867 27.8793 15.874 28.0367 16.0293Z" fill="#9D9D9D"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M21.8114 16.0293C21.9688 15.874 22.1824 15.7867 22.405 15.7867C22.6277 15.7867 22.8412 15.874 22.9987 16.0293L25.5177 18.5144C25.5979 18.5908 25.6619 18.6822 25.7059 18.7833C25.7499 18.8844 25.773 18.9931 25.774 19.1031C25.775 19.213 25.7537 19.3221 25.7115 19.4239C25.6693 19.5257 25.6069 19.6182 25.5281 19.696C25.4493 19.7738 25.3555 19.8353 25.2523 19.8769C25.1491 19.9186 25.0386 19.9396 24.9271 19.9386C24.8156 19.9376 24.7054 19.9148 24.6029 19.8714C24.5005 19.828 24.4078 19.7649 24.3304 19.6857L21.8114 17.2006C21.6539 17.0453 21.5655 16.8346 21.5655 16.6149C21.5655 16.3953 21.6539 16.1846 21.8114 16.0293Z" fill="#9D9D9D"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M24.924 18.2717C24.7013 18.2717 24.4878 18.1844 24.3303 18.0291C24.1728 17.8737 24.0844 17.663 24.0844 17.4433V10.8163C24.0844 10.5966 24.1728 10.3859 24.3303 10.2305C24.4878 10.0752 24.7013 9.98792 24.924 9.98792C25.1467 9.98792 25.3603 10.0752 25.5178 10.2305C25.6753 10.3859 25.7637 10.5966 25.7637 10.8163V17.4433C25.7637 17.663 25.6753 17.8737 25.5178 18.0291C25.3603 18.1844 25.1467 18.2717 24.924 18.2717Z" fill="#9D9D9D"/>
                                    </svg>

                                    <p class="sm:text-sm text-xs font-semibold">রাউন্ড ট্রিপ</p>
                                </div>
                                <div class="svg w-1/3">

                                </div>
                            </div>
                        </div>
                    </div>

                    <!--Journey Date and Time-->
                    <div class="width-set flex space-x-2">
                        <div class="relative w-full mt-6">
                            <label for="journey_date" class="text-sm font-semibold capitalize">
                                {{ $t("triCreateForm.journeyDate") }}
                            </label>
                            <SelectCustomDate
                                class="tracking-widest text-gray-500 rounded bg-white mb-4 w-full p-2 border border-gray-200 text-xs"
                                @change-date="journeyDateChanged"
                                style="word-spacing: 10px"
                            />
                            <span
                                class="text-red-400 block text-xs mt-1"
                                v-text="form.error.get('journey_date')"
                                v-if="form.error.has('journey_date')"
                            ></span>
                        </div>
                        <div class="relative w-full mt-6">
                            <label for="journey_time" class="text-sm font-semibold capitalize">
                                {{ $t("triCreateForm.journeyTime") }}
                            </label>
                            <select
                                v-model="form.journey_time"
                                class="tracking-widest text-gray-500 rounded bg-white mb-4 w-full p-2 border border-gray-200 text-xs"
                                style="word-spacing: 10px"
                            >
                                <option
                                    v-for="time in timeListItems"
                                    :value="time.value" :key="time.value">
                                    {{ time.time }}
                                </option>
                            </select>

                            <span
                                class="text-red-400 block text-xs mt-1"
                                v-text="form.error.get('journey_date')"
                                v-if="form.error.has('journey_date')"
                            ></span>
                        </div>
                    </div>
                    <!--End Journey Date and Time-->

                    <div v-if="form.type === 'round'" class="width-set flex space-x-2">
                        <div class="relative w-full">
                            <label for="journey_date" class="text-sm font-semibold capitalize">
                                {{ $t("triCreateForm.returnDate") }}
                            </label>
                            <SelectCustomDate
                                class="tracking-widest text-gray-500 rounded bg-white mb-4 w-full p-2 border border-gray-200 text-xs"
                                @change-date="returnDateChanged"
                                style="word-spacing: 10px"
                            />
                            <span
                                class="text-red-400 block text-xs mt-1"
                                v-text="form.error.get('return_date')"
                                v-if="form.error.has('return_date')"
                            ></span>
                        </div>
                        <div class="relative w-full">
                            <label for="journey_time" class="text-sm font-semibold capitalize">
                                {{ $t("triCreateForm.returnTime") }}
                            </label>
                            <select
                                v-model="form.return_time"
                                class="tracking-widest text-gray-500 rounded bg-white mb-4 w-full p-2 border border-gray-200 text-xs"
                                style="word-spacing: 10px"
                            >
                                <option
                                    v-for="time in timeListItems"
                                    :value="time.value" :key="time.value">
                                    {{ time.time }}
                                </option>
                            </select>

                            <span
                                class="text-red-400 block text-xs mt-1"
                                v-text="form.error.get('journey_date')"
                                v-if="form.error.has('journey_date')"
                            ></span>
                        </div>
                    </div>

                    <div class="width-set flex">
                        <div class="relative w-full">
                            <label for="car_type" class="text-sm font-semibold capitalize">
                                গাড়ির ধরণ নির্বাচন করুন
                            </label>
                            <div class="car-lists flex flex-row justify-between gap-1">
                                <div class="car-single py-2 flex flex-col justify-between items-center"
                                     :class="form.car_type === car.type ? 'active': ''" v-for="car in carLists" :key="car.id"
                                     @click="selectCar(car)">
                                    <div class="car-image">
                                        <img :src="`images/${car.image}`" alt="car rental">
                                    </div>
                                    <div class="car-info">
                                        <p class="font-semibold text-xs">{{ car.name }} {{ car.capacity }} সিট</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="width-set flex ">
                        <div class="relative w-full mt-2">
                            <textarea
                                class="trip-note-text-area text-black rounded mb-4 w-full p-2 h-20 border border-gray-200 text-xs"
                                id="trip_note"
                                placeholder="প্রোভাইডারকে ট্রিপ সম্পর্কিত অতিরিক্ত তথ্য জানাতে  বিবরণ লিখুন। (যদি থাকে)"
                                v-model="form.trip_note"
                            ></textarea>
                            <span
                                class="text-red-400 block text-sm mt-1"
                                v-text="form.error.get('trip_note')"
                                v-if="form.error.has('trip_note')"
                            ></span>
                        </div>
                    </div>

                    <div class="flex justify-center">
                        <p class="text-red-600">{{ errorMessage }}</p>
                    </div>

                    <div class="width-set flex justify-center">
                        <button
                            class="trip-create-button w-full flex items-center justify-center gap-3 rounded capitalize h-10 mx-auto mt-2 hover:bg-red-700 transition duration-400  py-2"
                            :class="submitClicked ? 'cursor-not-allowed': ''"
                            :disabled="submitClicked"
                            @click.prevent="showSecondPage">
                        <span class="text-gray-white capitalize text-lg ">
                            এগিয়ে যান
                        </span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25"
                                 fill="none">
                                <path
                                    d="M14.138 16.029L15.552 17.443L20.502 12.493L15.552 7.54297L14.138 8.95797L16.636 11.456H8.49805C7.43718 11.456 6.41977 11.8774 5.66962 12.6275C4.91947 13.3777 4.49805 14.3951 4.49805 15.456V17.456H6.49805V15.456C6.49805 14.9255 6.70876 14.4168 7.08383 14.0418C7.45891 13.6667 7.96761 13.456 8.49805 13.456H16.71L14.138 16.029Z"
                                    fill="white"/>
                            </svg>
                        </button>
                    </div>
                </div>

                <div v-show="secondPage" class="width-set">
                    <div
                        class="confirm-information-trip max-w-3xl mx-auto mt-3 bg-white p-5 rounded-lg leading-loose sm:mt-0 sm:ml-4 sm:text-left">
                        <h3 class="text-lg leading-6 font-bold text-red-600 text-center" id="modal-title">
                            তথ্য নিশ্চিতকরণ
                        </h3>

                        <div class="mt-2">
                            <div class="flex flex-row items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                    <g clip-path="url(#clip0_3034_25852)">
                                        <path d="M6.46875 14.8C5.15295 14.8 4.07921 14.6003 3.24753 14.2008C2.41584 13.8014 2 13.2861 2 12.655C2 12.2379 2.17999 11.8745 2.53997 11.5646C2.89996 11.2548 3.39648 11.0105 4.02956 10.8317L4.45781 12.1902C4.24679 12.2498 4.05438 12.3244 3.8806 12.414C3.70681 12.5037 3.58889 12.584 3.52682 12.655C3.68819 12.8457 4.06059 13.0125 4.64401 13.1555C5.22743 13.2985 5.83568 13.37 6.46875 13.37C7.10182 13.37 7.7133 13.2985 8.30317 13.1555C8.89305 13.0125 9.26842 12.8457 9.4293 12.655C9.36723 12.5835 9.24931 12.5029 9.07552 12.4133C8.90174 12.3237 8.70933 12.2494 8.49831 12.1902L8.92656 10.8317C9.55964 11.0105 10.0532 11.2548 10.4072 11.5646C10.7612 11.8745 10.938 12.2379 10.9375 12.655C10.9375 13.2866 10.5217 13.8021 9.68997 14.2015C8.85829 14.601 7.78455 14.8005 6.46875 14.8ZM6.46875 12.655C6.3322 12.655 6.20807 12.6161 6.09635 12.5385C5.98464 12.4608 5.90395 12.3566 5.8543 12.226C5.56879 11.3799 5.20881 10.6709 4.77435 10.0989C4.33989 9.52687 3.91784 8.97871 3.5082 8.45437C3.11098 7.93004 2.76664 7.38783 2.47518 6.82775C2.18372 6.26767 2.03774 5.5765 2.03724 4.75425C2.03724 3.56258 2.46549 2.55562 3.32201 1.73337C4.17852 0.911125 5.22743 0.5 6.46875 0.5C7.71007 0.5 8.75898 0.911125 9.61549 1.73337C10.472 2.55562 10.9003 3.56258 10.9003 4.75425C10.9003 5.5765 10.7575 6.26767 10.472 6.82775C10.1865 7.38783 9.83893 7.93004 9.4293 8.45437C9.03207 8.97871 8.61325 9.52687 8.17283 10.0989C7.73241 10.6709 7.3692 11.3799 7.0832 12.226C7.03355 12.3571 6.95286 12.4615 6.84115 12.5392C6.72943 12.6169 6.60529 12.6555 6.46875 12.655ZM6.46875 6.27362C6.90321 6.27362 7.27561 6.12467 7.58594 5.82675C7.89627 5.52883 8.05143 5.17133 8.05143 4.75425C8.05143 4.33717 7.89627 3.97967 7.58594 3.68175C7.27561 3.38383 6.90321 3.23487 6.46875 3.23487C6.03429 3.23487 5.66189 3.38383 5.35156 3.68175C5.04123 3.97967 4.88607 4.33717 4.88607 4.75425C4.88607 5.17133 5.04123 5.52883 5.35156 5.82675C5.66189 6.12467 6.03429 6.27362 6.46875 6.27362Z" fill="#BBC6D0"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_3034_25852">
                                            <rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                                <span class="text-primaryBlack font-notoSans font-semibold text-sm ml-1">{{ $t("triCreateForm.pickupLocation") }}</span>
                            </div>

                            <p class="text-primaryBlack font-notoSans text-sm font-medium my-2 p-2 border-set">
                                {{ form.pickup_full_address }}
                            </p>

                            <div v-if="form.via_full_address" class="flex flex-row items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                    <circle cx="8" cy="8.5" r="4.5" stroke="#9D9D9D"/>
                                </svg>
                                <p class="text-sm ml-2 font-notoSans text-black font-semibold">ভায়া লোকেশন</p>
                            </div>

                            <p v-if="form.via_full_address" class="text-primaryBlack font-notoSans text-sm font-medium my-2 p-2 border-set">
                                {{ form.via_full_address }}
                            </p>

                            <div class="flex flex-row items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                    <path d="M2.42871 1.64307V15.3574V1.64307ZM11.5716 9.02768H2.42871V1.64307H11.5716L8.52395 5.33537L11.5716 9.02768Z" fill="#BBC6D0"/>
                                    <path d="M2.42871 1.64307V15.3574M2.42871 1.64307V9.02768H11.5716L8.52395 5.33537L11.5716 1.64307H2.42871Z" stroke="#BBC6D0" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <span class="text-primaryBlack font-notoSans font-semibold text-sm ml-1">{{ $t("triCreateForm.destinationLocation") }}</span>
                            </div>
                            <p class="text-primaryBlack font-notoSans text-sm font-medium my-2 p-2 border-set">
                                {{ form.destination_full_address }}
                            </p>

                            <div class="flex flex-row gap-1 w-full">
                                <div class="flex flex-row justify-between items-center p-2 w-1/2 border-set">
                                    <div class="flex flex-col gap-1 ">
                                        <p class="text-xs text-gray-400 font-semibold font-notoSans">ট্রিপের ধরন</p>
                                        <p class="text-xs text-primaryBlack font-notoSans font-semibold">{{ form.type === "round" ? "Up-Down" : "One Way" }}</p>
                                    </div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">
                                        <path d="M16.8391 1.42445C13.8691 1.37975 9.74335 1.4451 8.89393 3.78432L6.80698 8.80468C6.71441 8.69612 6.59302 8.61755 6.45762 8.57855L5.61738 8.33621C5.52499 8.30935 5.42834 8.30147 5.33296 8.313C5.23759 8.32454 5.14538 8.35527 5.06162 8.40344C4.97787 8.45161 4.90421 8.51626 4.84489 8.59368C4.78557 8.67111 4.74175 8.75978 4.71595 8.85461L4.27759 10.4503C4.25143 10.545 4.24377 10.6441 4.25505 10.7418C4.26632 10.8396 4.29631 10.9341 4.34329 11.0199C4.39027 11.1058 4.45332 11.1812 4.52882 11.242C4.60432 11.3028 4.69079 11.3477 4.78327 11.3742L5.62376 11.6168C5.65181 11.6246 5.67986 11.6273 5.70791 11.632C5.54726 12.0424 5.4473 12.4936 5.4473 12.7621V18.5971C5.4473 18.8961 5.5697 19.0347 5.76401 19.0995V20.6539C5.76371 20.7919 5.79 20.9286 5.84137 21.0562C5.89274 21.1837 5.96818 21.2996 6.06336 21.3972C6.15854 21.4948 6.27159 21.5721 6.396 21.6248C6.52042 21.6774 6.65376 21.7044 6.78836 21.7041H9.53654C9.67114 21.7044 9.80448 21.6774 9.9289 21.6248C10.0533 21.5721 10.1664 21.4948 10.2615 21.3972C10.3567 21.2996 10.4322 21.1837 10.4835 21.0562C10.5349 20.9286 10.5612 20.7919 10.5609 20.6539V19.1565H23.4393V20.6539C23.4391 20.7919 23.4655 20.9286 23.5169 21.0561C23.5683 21.1837 23.6437 21.2995 23.7389 21.3971C23.8341 21.4947 23.9472 21.572 24.0716 21.6247C24.196 21.6774 24.3293 21.7043 24.464 21.7041H27.2116C27.3463 21.7044 27.4796 21.6774 27.6041 21.6248C27.7285 21.5721 27.8416 21.4948 27.9368 21.3972C28.032 21.2996 28.1075 21.1838 28.1589 21.0562C28.2104 20.9287 28.2367 20.7919 28.2365 20.6539V19.0998C28.431 19.0349 28.5527 18.8964 28.5527 18.5973V12.7624C28.5527 12.4939 28.4525 12.0427 28.2921 11.6322C28.3201 11.6278 28.3482 11.6252 28.3762 11.6171L29.217 11.3745C29.3094 11.348 29.3959 11.303 29.4713 11.2422C29.5468 11.1814 29.6098 11.1059 29.6568 11.0201C29.7037 10.9343 29.7337 10.8398 29.745 10.7421C29.7562 10.6443 29.7486 10.5453 29.7224 10.4506L29.2845 8.85487C29.2587 8.76003 29.2149 8.67135 29.1555 8.59393C29.0962 8.5165 29.0225 8.45185 28.9387 8.40369C28.8549 8.35552 28.7627 8.32479 28.6673 8.31325C28.5719 8.30172 28.4753 8.30961 28.3829 8.33647L27.5426 8.57881C27.4072 8.61797 27.2858 8.69652 27.193 8.80494L25.1061 3.78458C24.1957 1.40981 19.8091 1.46916 16.8391 1.42445ZM25.3452 9.12178C25.3947 9.27236 25.2468 9.37275 25.092 9.3819C25.092 9.3819 24.5861 9.42582 23.8884 9.48359C23.3575 8.21203 22.1238 7.31588 20.6945 7.31588C19.126 7.31588 17.7943 8.39555 17.3672 9.86579C17.2489 9.86736 17.1114 9.87259 17.0015 9.87259C14.2992 9.87259 8.90795 9.3819 8.90795 9.3819C8.75342 9.37249 8.60526 9.2721 8.65474 9.12178C10.731 2.63301 10.7929 3.12082 16.8852 3.18906C22.9773 3.25703 23.0127 2.79352 25.3452 9.12178ZM20.6945 8.54221C21.0706 8.54087 21.4412 8.63555 21.7727 8.81769C22.1042 8.99984 22.3863 9.26372 22.5935 9.58555C21.3733 9.67835 19.969 9.77325 18.6603 9.82841C18.8486 9.44086 19.1389 9.11504 19.4984 8.88775C19.8578 8.66046 20.2722 8.54077 20.6945 8.54221ZM6.64862 10.648C6.66698 10.6759 6.68483 10.7039 6.70523 10.7308H6.62618L6.64862 10.648ZM7.99861 12.2777C8.5331 12.2688 11.4024 13.2588 11.4024 13.2588C11.7607 13.3623 12.0761 14.0567 12.0743 14.4383C12.069 15.7238 8.83349 15.2775 7.51997 15.2827C7.4317 15.2829 7.34427 15.2652 7.26269 15.2307C7.18111 15.1961 7.10698 15.1454 7.04455 15.0815C6.98213 15.0175 6.93264 14.9415 6.89891 14.8579C6.86519 14.7743 6.8479 14.6846 6.84803 14.5941V12.9668C6.84803 12.5851 7.46412 12.2871 7.99861 12.2777ZM26.0014 12.2777C26.5359 12.2868 27.1519 12.5851 27.1519 12.9668V14.5941C27.1521 14.6847 27.1349 14.7743 27.1011 14.858C27.0674 14.9416 27.0179 15.0176 26.9555 15.0816C26.8931 15.1456 26.819 15.1964 26.7374 15.2309C26.6558 15.2655 26.5683 15.2832 26.48 15.283C25.1667 15.2778 21.931 15.7238 21.9256 14.4383C21.9239 14.0567 22.2393 13.3623 22.5976 13.2588C22.5976 13.2588 25.4669 12.2688 26.0014 12.2777Z" fill="#1A1A1A"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.3607 30.8476C18.56 31.0518 18.8302 31.1665 19.1119 31.1665C19.3936 31.1665 19.6639 31.0518 19.8631 30.8476L23.0507 27.5798C23.1521 27.4793 23.2331 27.3591 23.2888 27.2262C23.3445 27.0933 23.3738 26.9504 23.375 26.8058C23.3762 26.6611 23.3493 26.5177 23.2959 26.3838C23.2425 26.25 23.1636 26.1284 23.0638 26.0261C22.9641 25.9238 22.8454 25.8429 22.7149 25.7882C22.5843 25.7334 22.4444 25.7058 22.3033 25.7071C22.1622 25.7083 22.0228 25.7384 21.8931 25.7955C21.7635 25.8526 21.6463 25.9355 21.5483 26.0396L18.3607 29.3074C18.1615 29.5116 18.0496 29.7886 18.0496 30.0775C18.0496 30.3663 18.1615 30.6433 18.3607 30.8476Z" fill="#1A1A1A"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.3608 22.7719C18.1616 22.9762 18.0497 23.2532 18.0497 23.542C18.0497 23.8309 18.1616 24.1079 18.3608 24.3121L21.5483 27.5799C21.7487 27.7783 22.0171 27.8881 22.2957 27.8856C22.5743 27.8832 22.8408 27.7686 23.0378 27.5667C23.2348 27.3647 23.3465 27.0915 23.3489 26.8059C23.3513 26.5203 23.2442 26.2451 23.0507 26.0397L19.8631 22.7719C19.6639 22.5677 19.3937 22.453 19.112 22.453C18.8302 22.453 18.56 22.5677 18.3608 22.7719Z" fill="#1A1A1A"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.6248 26.8095C10.6248 27.0983 10.7368 27.3754 10.936 27.5797C11.1353 27.784 11.4056 27.8987 11.6874 27.8987H20.1875C20.4693 27.8987 20.7395 27.784 20.9388 27.5797C21.1381 27.3754 21.25 27.0983 21.25 26.8095C21.25 26.5206 21.1381 26.2435 20.9388 26.0392C20.7395 25.835 20.4693 25.7202 20.1875 25.7202H11.6874C11.4056 25.7202 11.1353 25.835 10.936 26.0392C10.7368 26.2435 10.6248 26.5206 10.6248 26.8095Z" fill="#1A1A1A"/>
                                    </svg>
                                </div>
                                <div class="flex flex-row justify-between items-center p-2 w-1/2 border-set">
                                    <div class="flex flex-col gap-1">
                                        <p class="text-xs text-gray-400 font-semibold font-notoSans">গাড়ির ধরন</p>
                                        <p class="text-xs text-primaryBlack font-notoSans font-semibold capitalize">{{ form.car_type + ' '+ getTripCarType(form.car_type) }}</p>
                                    </div>
                                    <img class="w-14 h-10" src="/images/car1.png" alt="Sedan Car">
                                </div>
                            </div>

                            <div class="border-set divide-y mt-2">
                                <p class="flex justify-center p-2 text-gray-600 text-base font-notoSans font-semibold">ট্রিপের সময়</p>
                                <div class="flex flex-row justify-between items-center p-2">
                                    <p class="text-base text-primaryBlack font-notoSans font-medium">যাত্রা শুরু</p>
                                    <p class="text-base text-primaryBlack font-notoSans font-medium">
                                        {{
                                            convertMonthName(form.journey_date) + ' ' + engToBdNum(form.journey_date.split('-')[2]) + ' ' + getFullDayName(form.journey_date) + ', ' + timeConvertToText(form.journey_time)
                                        }}
                                    </p>
                                </div>
                                <div v-if="form.type === 'round'" class="flex flex-row justify-between items-center p-2">
                                    <p class="text-base text-primaryBlack font-notoSans font-medium">ফেরার সময়</p>
                                    <p v-if="form.return_date && form.return_time" class="text-base text-primaryBlack font-notoSans font-medium">
                                        {{
                                            convertMonthName(form.return_date) + ' ' + engToBdNum(form.return_date.split('-')[2]) + ' ' + getFullDayName(form.return_date) + ', ' + timeConvertToText(form.return_time)
                                        }}
                                    </p>
                                </div>
                            </div>

                            <div class="border-set divide-y mt-2">
                                <p class="flex justify-center p-2 text-gray-600 text-base font-notoSans font-semibold">সম্ভাব্য</p>
                                <div class="flex flex-row justify-around items-center p-2">
                                    <div class="grid justify-items-center">
                                        <p class="text-grayTwo font-medium font-notoSans text-xs">দূরত্ব</p>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                                            <g clip-path="url(#clip0_3111_30590)">
                                                <path d="M8.5 12.3332L6.5 11.3332L2.5 13.3332V4.6665L6.5 2.6665L10.5 4.6665L14.5 2.6665V7.6665" stroke="#1A1A1A" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M6.5 2.6665V11.3332" stroke="#1A1A1A" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M10.5 4.6665V8.33317" stroke="#1A1A1A" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M14.581 13.4139C14.8608 13.1343 15.0513 12.7779 15.1285 12.3899C15.2057 12.0019 15.1662 11.5998 15.0148 11.2343C14.8635 10.8688 14.6071 10.5564 14.2782 10.3366C13.9493 10.1168 13.5626 9.99951 13.167 9.99951C12.7714 9.99951 12.3847 10.1168 12.0558 10.3366C11.7269 10.5564 11.4705 10.8688 11.3192 11.2343C11.1678 11.5998 11.1282 12.0019 11.2055 12.3899C11.2827 12.7779 11.4732 13.1343 11.753 13.4139C12.0317 13.6933 12.503 14.1106 13.167 14.6666C13.8677 14.0733 14.3397 13.6559 14.581 13.4139Z" stroke="#1A1A1A" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M13.167 12V12.0086" stroke="#1A1A1A" stroke-linecap="round" stroke-linejoin="round"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_3111_30590">
                                                    <rect width="16" height="16" fill="white" transform="translate(0.5)"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        <p class="text-primaryBlack font-medium font-roboto text-sm">
                                            {{ $i18n.locale === "bn" ? (form?.distance / 1000).toFixed(1).toLocaleString("bn-BD") : (form?.distance / 1000).toFixed(1) }} {{ $t("km") }}
                                        </p>
                                    </div>

                                    <svg xmlns="http://www.w3.org/2000/svg" width="2" height="38" viewBox="0 0 2 38" fill="none">
                                        <path d="M1 1L0.999998 37" stroke="#E0E5F4" stroke-linecap="round"/>
                                    </svg>

                                    <div class="grid justify-items-center">
                                        <p class="text-grayTwo font-medium font-notoSans text-xs">সময়</p>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                                            <g clip-path="url(#clip0_3111_30602)">
                                                <path d="M2.5 8C2.5 8.78793 2.65519 9.56815 2.95672 10.2961C3.25825 11.0241 3.70021 11.6855 4.25736 12.2426C4.81451 12.7998 5.47595 13.2417 6.2039 13.5433C6.93185 13.8448 7.71207 14 8.5 14C9.28793 14 10.0681 13.8448 10.7961 13.5433C11.5241 13.2417 12.1855 12.7998 12.7426 12.2426C13.2998 11.6855 13.7417 11.0241 14.0433 10.2961C14.3448 9.56815 14.5 8.78793 14.5 8C14.5 7.21207 14.3448 6.43185 14.0433 5.7039C13.7417 4.97595 13.2998 4.31451 12.7426 3.75736C12.1855 3.20021 11.5241 2.75825 10.7961 2.45672C10.0681 2.15519 9.28793 2 8.5 2C7.71207 2 6.93185 2.15519 6.2039 2.45672C5.47595 2.75825 4.81451 3.20021 4.25736 3.75736C3.70021 4.31451 3.25825 4.97595 2.95672 5.7039C2.65519 6.43185 2.5 7.21207 2.5 8Z" stroke="#1A1A1A" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M8.5 8L10.5 9.33333" stroke="#1A1A1A" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M8.5 4.6665V7.99984" stroke="#1A1A1A" stroke-linecap="round" stroke-linejoin="round"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_3111_30602">
                                                    <rect width="16" height="16" fill="white" transform="translate(0.5)"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        <p class="text-primaryBlack font-medium font-roboto text-sm">
                                            {{ $i18n.locale === "bn" ? Math.floor(form.duration / 3600).toLocaleString("bn-BD") : Math.floor(form.duration / 3600) }}{{
                                                $t("hour")
                                            }}
                                            {{
                                                $i18n.locale === "bn" ? Math.floor((form.duration % 3600) / 60).toLocaleString("bn-BD") : Math.floor((form.duration % 3600) / 60)
                                            }}{{ $t("min") }}
                                        </p>
                                    </div>

                                    <svg xmlns="http://www.w3.org/2000/svg" width="2" height="38" viewBox="0 0 2 38" fill="none">
                                        <path d="M1 1L0.999998 37" stroke="#E0E5F4" stroke-linecap="round"/>
                                    </svg>

                                    <div class="grid justify-items-center">
                                        <p class="text-grayTwo font-medium font-notoSans text-xs">ভাড়া</p>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <g clip-path="url(#clip0_3111_30612)">
                                                <path d="M5.33301 5.33341L5.70167 5.14941C5.80329 5.09864 5.91619 5.07467 6.02967 5.07978C6.14315 5.08489 6.25344 5.11891 6.35008 5.17862C6.44672 5.23832 6.52649 5.32173 6.58184 5.42093C6.6372 5.52012 6.66628 5.63182 6.66634 5.74541V10.0001C6.66634 10.3537 6.80682 10.6928 7.05687 10.9429C7.30691 11.1929 7.64605 11.3334 7.99967 11.3334H8.33301C8.77504 11.3334 9.19896 11.1578 9.51152 10.8453C9.82408 10.5327 9.99967 10.1088 9.99967 9.66675V9.33341H9.33301" stroke="#1A1A1A" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M5.33301 7.3335H9.99967" stroke="#1A1A1A" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M2 8C2 8.78793 2.15519 9.56815 2.45672 10.2961C2.75825 11.0241 3.20021 11.6855 3.75736 12.2426C4.31451 12.7998 4.97595 13.2417 5.7039 13.5433C6.43185 13.8448 7.21207 14 8 14C8.78793 14 9.56815 13.8448 10.2961 13.5433C11.0241 13.2417 11.6855 12.7998 12.2426 12.2426C12.7998 11.6855 13.2417 11.0241 13.5433 10.2961C13.8448 9.56815 14 8.78793 14 8C14 6.4087 13.3679 4.88258 12.2426 3.75736C11.1174 2.63214 9.5913 2 8 2C6.4087 2 4.88258 2.63214 3.75736 3.75736C2.63214 4.88258 2 6.4087 2 8Z" stroke="#1A1A1A" stroke-linecap="round" stroke-linejoin="round"/>
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_3111_30612">
                                                    <rect width="16" height="16" fill="white"/>
                                                </clipPath>
                                            </defs>
                                        </svg>
                                        <p class="text-primaryBlack font-medium font-roboto text-sm">
                                            {{ $i18n.locale === "bn" ? Math.floor(minPrice).toLocaleString("bn-BD") : Math.floor(minPrice) }}
                                            -
                                            {{ $i18n.locale === "bn" ? Math.floor(maxPrice).toLocaleString("bn-BD") : Math.floor(maxPrice) }}
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <p v-if="form.trip_note" class="text-primaryBlack font-bold font-notoSans text-xs mt-2">নোট:</p>
                            <div v-if="form.trip_note" class="border-set p-2">
                                <p class="font-notoSans text-black text-sm">{{ form.trip_note ?? 'No Note' }}</p>
                            </div>

                            <div class="flex justify-between items-center gap-2 mt-2">
                                <div
                                    @click.prevent="secondPage=!secondPage"
                                    class="cancel-button w-1/2 flex justify-center items-center"
                                >
                                    <p>{{ $t("triCreateForm.back") }}</p>
                                </div>
                                <button
                                    class="ok-button w-1/2 flex justify-center items-center"
                                    :class="submitClicked ? 'cursor-not-allowed' : ''"
                                    :disabled="submitClicked"
                                    type="submit">
                                    <span v-if="form.loading" class="mdi mdi-cached inline-block loader mr-2"></span>
                                    নিশ্চিত করুন
                                </button>
                            </div>


<!--                            <div class="estimated-time-distance my-3">
                                <div class="text-sm text-black flex flex-wrap gap-3 items-center">
                                    <div class="flex items-center gap-1">
                                        <span class="mdi mdi-trending-up"></span>
                                        আনুমানিক ভাড়াঃ
                                        {{ $i18n.locale === "bn" ? Math.floor(minPrice).toLocaleString("bn-BD") : Math.floor(minPrice) }}
                                           -
                                        {{ $i18n.locale === "bn" ? Math.floor(maxPrice).toLocaleString("bn-BD") : Math.floor(maxPrice) }}
                                        টাকা
                                    </div>
                                </div>
                            </div>-->
                        </div>
                    </div>
                </div>
                <div>
                    <Loader :show="showLoader"/>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import SearchableDropdown from "@/components/atom/SearchableDropdown";
import Datepicker from "@/components/atom/Datepicker";
import VueGoogleAutocomplete from "vue-google-autocomplete";
import Form from "@/services/form";
import {mapGetters, mapMutations} from "vuex";
import userMixin from "@/mixins/userMixin";
import engToBd from "@/mixins/engToBd"
import priceRange from "@/mixins/priceRange";
import fotmatTimeMixin from "@/mixins/fotmatTimeMixin";
import GeoSelector from "@/components/atom/GeoSelector.vue";
import GeoSelectorWithoutDivisionUnion from "@/components/atom/GeoSelectorWithoutDivisionUnion";
import PriceManger from "@/services/module/price";
import {inject} from "vue";
import {fetchDistrictWithoutDivision} from "@/services/module/api.geolocation";
import axios from 'axios';
import moment from 'moment';
import Loader from "@/components/atom/LoadingComponent";
import address from "@/components/atom/Address.vue";
import CustomDate from "@/components/atom/CustomDate.vue";
import CustomTime from "@/components/atom/CustomTime.vue"
import Drawer from "@/components/atom/Drawer.vue";
import SelectCustomDate from "@/components/atom/SelectCustomDate.vue";

export default {
    name: "TripCreateComponent",
    mixins: [userMixin, fotmatTimeMixin, engToBd, priceRange],
    components: {
        SelectCustomDate,
        SearchableDropdown,
        Datepicker,
        VueGoogleAutocomplete,
        GeoSelector,
        GeoSelectorWithoutDivisionUnion,
        Loader,
        CustomDate,
        CustomTime,
        Drawer
    },
    setup() {
        //provided form app component
        const showError = inject("showError");
        const showSuccess = inject("showSuccess");
        return {showError, showSuccess};
    },
    computed: {
        ...mapGetters({
            selectedTrip: "getSelectedTrip",
        }),
        showEstimatedPrice() {
            return this.isPriceRangeValid && this.form.distance && this.form.type === 'oneway' && this.form.car_type === 'sedan car';
        },
        isMyTripage() {
            return this.$route.name == "RequestTrips";
        },
        address() {
            return address
        },
        journeyDate() {
            return moment(this.selectedTrip.journey_date).format('YYYY-DD-MM')
        },
        returnDate() {
            return moment(this.selectedTrip.return_date).format('YYYY-DD-MM')
        },
        timeListItems() {
            let nowTime = moment().add(1, 'hours').format('HH:mm:ss');
            if (this.form.journey_date === moment().format('YYYY-MM-DD') && this.form.type === 'oneway') {
                return this.timeList.filter((item) => {
                    return item.value > nowTime;
                });
            } else if (this.form.return_date === moment().format('YYYY-MM-DD') && this.form.type === 'round') {
                return this.timeList.filter((item) => {
                    return item.value > nowTime;
                });
            } else {
                return this.timeList;
            }
        }
    },
    props: {
        checkBoxlabelColor: {
            default: "text-gray-100",
        },
        columnStyle: {
            default: "flex flex-wrap lg:space-x-5",
        },
        type: {
            default: 'modal'
        }
    },
    data() {
        return {
            fields: [
                "address_components",
                "geometry",
                "type",
                "name",
                "formatted_address",
                "adr_address",
                "place_id",
            ],
            secondPage: false,
            viaShow: false,
            showLoader: false,
            submitClicked: false,
            isPickupSelected: false,
            isViaSelected: false,
            isDestinationSelected: false,
            showPickupRecentSearches: false,
            showDestinationRecentSearches: false,
            recentSearches: [],
            isPriceRange: false,
            priceManager: new PriceManger(),
            loading: false,
            journey_date: "",
            journey_time: "",
            return_date: "",
            return_time: "",
            isPriceRangeValid: false,
            minPrice:'',
            maxPrice:'',
            pickup_district: "",
            destination_district: "",
            priceRange: {},
            cars: [],
            provider_cars: [],
            carLoading: false,
            noCarMessage: "Car is busy",
            form: new Form({
                pickup_full_address: "",
                pickup_division: "",
                destination_full_address: "",
                destination_division: "",
                via_full_address: "",
                journey_date: moment().format('YYYY-MM-DD'),
                journey_time: "",
                created_by: "",
                car_id: "",
                car_type: "",
                return_date: "",
                return_time: "",
                price: "",
                status: "",
                no_of_seat: "",
                type: "oneway",
                pickup_district_id: "",
                pickup_sub_district_id: "",
                destination_district_id: "",
                destination_sub_district_id: "",
                pickup_specific_area: "",
                destination_specific_area: "",
                trip_note: "",
                distance: "",
                duration: "",
                pickup_lat: "",
                pickup_long: "",
                destination_lat: "",
                destination_long: "",
                via_lat: "",
                via_long: "",
            }),
            error: {
                pickup: false,
                pickup_message: "",
                destination: false,
                destination_message: "",
                journey_date: false,
                journey_time: false,
                return_date: false,
                return_time: false,
                car_type: false,
            },
            errorMessage: "",
            noCar: false,
            allDistrictList: [],
            startLocation: null,
            endLocation: null,
            viaLocation: null,
            isDrawerOpen: false,
            drawerContent: null,
            deviceType: '',
            timeList: [
                {
                    time: "রাত ১২: ০০",
                    value: "00:00:00",
                },
                {
                    time: "রাত  ১২: ৩০",
                    value: "00:30:00",
                },

                {
                    time: "রাত ০১: ০০",
                    value: "01:00:00",
                },
                {
                    time: "রাত ০১: ৩০",
                    value: "01:30:00",
                },

                {
                    time: "রাত ০২: ০০",
                    value: "02:00:00",
                },
                {
                    time: "রাত ০২: ৩০",
                    value: "02:30:00",
                },

                {
                    time: "রাত ০৩: ০০",
                    value: "03:00:00",
                },
                {
                    time: "রাত ০৩: ৩০",
                    value: "03:30:00",
                },

                {
                    time: "রাত ০৪: ০০",
                    value: "04:00:00",
                },
                {
                    time: "রাত ০৪: ৩০",
                    value: "04:30:00",
                },

                {
                    time: "সকাল ০৫: ০০",
                    value: "05:00:00",
                },
                {
                    time: "সকাল ০৫: ৩০",
                    value: "05:30:00",
                },

                {
                    time: "সকাল ০৬: ০০",
                    value: "06:00:00",
                },
                {
                    time: "সকাল ০৬: ৩০",
                    value: "06:30:00",
                },

                {
                    time: "সকাল ০৭: ০০",
                    value: "07:00:00",
                },
                {
                    time: "সকাল ০৭: ৩০",
                    value: "07:30:00",
                },

                {
                    time: "সকাল ০৮: ০০",
                    value: "08:00:00",
                },
                {
                    time: "সকাল ০৮: ৩০",
                    value: "08:30:00",
                },

                {
                    time: "সকাল ০৯: ০০",
                    value: "09:00:00",
                },
                {
                    time: "সকাল ০৯: ৩০",
                    value: "09:30:00",
                },

                {
                    time: "সকাল ১০: ০০",
                    value: "10:00:00",
                },
                {
                    time: "সকাল ১০: ৩০",
                    value: "10:30:00",
                },

                {
                    time: "দুপুর ১১: ০০",
                    value: "11:00:00",
                },
                {
                    time: "দুপুর ১১: ৩০",
                    value: "11:30:00",
                },

                {
                    time: "দুপুর ১২: ০০",
                    value: "12:00:00",
                },
                {
                    time: "দুপুর ১২: ৩০",
                    value: "12:30:00",
                },

                {
                    time: "দুপুর ০১: ০০",
                    value: "13:00:00",
                },
                {
                    time: "দুপুর ০১: ৩০",
                    value: "13:30:00",
                },

                {
                    time: "দুপুর ০২: ০০",
                    value: "14:00:00",
                },
                {
                    time: "দুপুর ০২: ৩০",
                    value: "14:30:00",
                },

                {
                    time: "দুপুর ০৩: ০০",
                    value: "15:00:00",
                },
                {
                    time: "দুপুর ০৩: ৩০",
                    value: "15:30:00",
                },

                {
                    time: "বিকাল ০৪: ০০",
                    value: "16:00:00",
                },
                {
                    time: "বিকাল  ০৪: ৩০",
                    value: "16:30:00",
                },

                {
                    time: "বিকাল ০৫: ০০",
                    value: "17:00:00",
                },
                {
                    time: "বিকাল ০৫: ৩০",
                    value: "17:30:00",
                },

                {
                    time: "বিকাল ০৬: ০০",
                    value: "18:00:00",
                },
                {
                    time: "বিকাল  ০৬: ৩০",
                    value: "18:30:00",
                },

                {
                    time: "সন্ধ্যা ০৭: ০০",
                    value: "19:00:00",
                },
                {
                    time: "সন্ধ্যা  ০৭: ৩০",
                    value: "19:30:00",
                },

                {
                    time: "রাত ০৮: ০০",
                    value: "20:00:00",
                },
                {
                    time: "রাত  ০৮: ৩০",
                    value: "20:30:00",
                },

                {
                    time: "রাত ০৯: ০০",
                    value: "21:00:00",
                },
                {
                    time: "রাত  ০৯: ৩০",
                    value: "21:30:00",
                },

                {
                    time: "রাত ১০: ০০",
                    value: "22:00:00",
                },
                {
                    time: "রাত  ১০: ৩০",
                    value: "22:30:00",
                },

                {
                    time: "রাত ১১: ০০",
                    value: "23:00:00",
                },
                {
                    time: "রাত  ১১: ৩০",
                    value: "23:30:00",
                },

            ],

            dform: new Form({
                action: "",
            }),
            carLists: [
                {
                    id: 1,
                    name: 'সেডান কার',
                    type: 'sedan car',
                    capacity: '4',
                    image: 'car1.png'
                },
                {
                    id: 2,
                    name: 'মিনি মাইক্রো',
                    type: 'mini micro',
                    capacity: '7',
                    image: 'car2.png'
                },

                {
                    id: 3,
                    name: 'মাইক্রো',
                    type: 'micro',
                    capacity: '10',
                    image: 'car3.png'
                }
            ],
            selectedCar: null,
        };
    },

    methods: {
        ...mapMutations({
            setDialog: "setDialog",
            setTrip: "trip/setTrip",
            updateTripListAfterCancel: "trip/updateTripListAfterCancel",
            setToaster: "setToaster",
        }),

        setDeviceType() {
            const platform = navigator.userAgent.toLowerCase();
            if (/(android|webos|iphone|ipad|ipod|blackberry|windows phone)/.test(platform)) {
                this.deviceType = 'mobile';
            } else if (/mac|win|linux/i.test(platform)) {
                this.deviceType = 'desktop';
            } else if (/tablet|ipad/i.test(platform)) {
                this.deviceType = 'tablet';
            } else {
                this.deviceType = 'unknown';
            }
        },
        showSecondPage() {
            if (this.formValidate()) {
                this.secondPage = true;
                if (this.form.type === 'round') {
                    this.form.distance = this.form.distance * 2
                }
                this.priceRange = this.getPriceRange(this.form.no_of_seat, this.form.type, this.form.distance);
                this.minPrice = this.priceRange.min;
                this.maxPrice = this.priceRange.max;
                console.log(this.priceRange)
            }
        },
        getTripCarType(type){
            if(type === 'mini micro'){
                return '(7 seats)';
            }
            if(type === 'sedan car'){
                return '(4 seats)';
            }
            if (type === 'premium car') {
                return '(4 seats)';
            }
            if(type === 'micro'){
                return '(10 seats)';
            }
        },
        toggleDrawer(type) {
            this.isDrawerOpen = !this.isDrawerOpen;
            this.drawerContent = type
        },

        closeDrawer() {
            this.isDrawerOpen = false;
            this.drawerContent = null
        },
        selectCar(car) {
            this.form.car_type = car.type
            this.selectedCar = car
            setTimeout(() => {
                this.closeDrawer()
            }, 500);
        },
        getCarInfo() {
            if (Array.isArray(this.cars) && this.cars.length == 0) {
                this.noCar = true
            }
        },

        formattedDate(dateString) {
            return moment(dateString).format('DD/MM/YYYY');
        },
        formattedTime(timeString) {
            return moment(timeString, 'HH:mm').format('h:mm A');
        },
        format24Hour(timeString) {
            return moment(timeString, 'h:mm A').format('HH:mm:ss');
        },
        formValidate() {
            this.loading = true
            if (this.userType === 'customer' && this.form.trip_note) {
                const regex = /(\+?8801[2-9]\d{8})|(01[2-9]\d{8})|([1-9]\d{9})|([\u09E6-\u09EF]{10})/g;
                const mobileNumbers = this.form.trip_note.match(regex);
                if (mobileNumbers && mobileNumbers.length > 0) {
                    this.form.trip_note = this.form.trip_note.replace(regex, '');
                }
            }

            if (!this.isPickupSelected) {
                this.showError(this.$t("tripValidation.selectLocation"));
                this.error.pickup = true;
                this.error.pickup_message = "গুগল থেকে যাত্রা শুরুর স্থান নির্বাচন করুন";
                this.loading = false
                return;
            }
            this.error.pickup = false;

            if (!this.isDestinationSelected) {
                this.showError(this.$t("tripValidation.selectLocation"));
                this.error.destination = true;
                this.error.destination_message = "গুগল থেকে গন্তব্য স্থান নির্বাচন করুন";
                this.loading = false
                return;
            }
            this.error.destination = false;


            let checkPrice = this.checkPrice();
            if (this.userType === 'provider' && !checkPrice) {
                this.showError("Price must be between " + parseInt(this.priceRange.min_price) + " to " + parseInt(this.priceRange.max_price) + " BDT");
                this.loading = false
                return;
            }

            if (!this.form.journey_date || !this.form.journey_time) {
                this.error.journey_date = true
                this.showError(this.$t("tripValidation.journeyDateTime"));
                this.loading = false
                return;
            }

            let journeyDateTime = new Date(this.form.journey_date + ' ' + this.form.journey_time);
            let currentDateTime = new Date();
            currentDateTime.setHours(currentDateTime.getHours() + 1);
            if (journeyDateTime <= currentDateTime) {
                this.error.journey_date = true
                this.showError(this.$t("tripValidation.journeyDateTimeValidation"));
                this.loading = false
                return;
            }

            this.error.journey_date = false
            if (this.form.type === 'round') {
                if (!this.form.return_date || !this.form.return_time) {
                    this.error.return_date = true
                    this.showError(this.$t("tripValidation.returnDateTime"));
                    this.loading = false
                    return;
                }

                let journeyDateTime = new Date(this.form.journey_date + ' ' + this.form.journey_time);
                let returnDateTime = new Date(this.form.return_date + ' ' + this.form.return_time);
                if (returnDateTime <= journeyDateTime) {
                    this.error.return_date = true
                    this.showError(this.$t("tripValidation.returnDateTimeValidation"));
                    this.loading = false
                    return;
                }
            }
            this.error.return_date = true

            if (this.form.trip_note && this.form.trip_note.length > 200) {

                this.showError(this.$t("tripValidation.tripNoteValidation"));
                this.loading = false
                return;
            }

            if (this.userType === 'customer' && !this.form.car_type) {
                this.error.car_type = true
                this.showError(this.$t("tripValidation.selectCarType"));
                this.loading = false
                return;
            }
            this.error.return_date = false
            if (this.userType === 'provider' && !this.form.price) {
                this.showError(this.$t("tripValidation.price"));
                this.loading = false
                return;
            }
            this.form.created_by = this.userType;
            if (this.form.car_type === 'sedan car') {
                this.form.no_of_seat = 4
            }
            if (this.form.car_type === 'premium car') {
                this.form.no_of_seat = 4
            }
            if (this.form.car_type === 'mini micro') {
                this.form.no_of_seat = 7
            }
            if (this.form.car_type === 'micro') {
                this.form.no_of_seat = 10
            }

            return true;
        },

        async submit() {
            this.loading = true;
            this.submitClicked = true;
            try {
                let submitResponse = await this.form.post("/trip/store");
                this.handleSubmit(submitResponse);
            } catch (err) {
                if (err.response) {
                    if (err.response.status === 500)
                        this.showError("Something went wrong");
                }
                this.loading = false;
                this.submitClicked = false;
            }
        },

        handleSubmit(submitResponse) {
            if (submitResponse.success) {
                //this.updateTripList(submitResponse.data);
                this.showSuccess(submitResponse.message);
                this.loading = false
                this.secondPage = false
                this.showLoader = true
                this.setDialog(false);
                setTimeout(() => {
                    this.$router.push({name: "TripBidding", params: {slug: submitResponse.data.id}});
                    this.submitClicked = false;
                }, 2000);
            } else {
                this.errorMessage = submitResponse.message;
            }
        },
        checkPrice() {
            if (this.isPriceRange) {
                return (
                    this.form.price >= parseInt(this.priceRange.min_price) &&
                    this.form.price <= parseInt(this.priceRange.max_price)
                );
            }
            if (!this.isPriceRange) return true;
        },
        updateTripList(data) {
            if (this.isMyTripage) {
                setTimeout(() => {
                    this.setTrip(data);
                }, 2000);
                if (this.$route.name == "RequestTrips") {
                    window.location.reload();
                }
            }
        },
        fetchCar() {
            if (this.userType == "provider") {
                this.form.get("/provider/index-idle-cars", {}).then((res) => {
                    this.cars = res.data;

                });
                this.carLoading = true
                this.form.get("/provider/index-cars", {}).then((res) => {
                    this.provider_cars = res.data;
                    this.carLoading = false
                });
            }
        },

        journeyDateChanged(date) {
            this.form.journey_date = date;
        },
        journeyTimeChanged(time) {
            this.form.journey_time = time
        },
        returnDateChanged(date) {
            this.form.return_date = date;
        },
        returnTimeChanged(time) {
            this.form.return_time = time
        },

        /**
         * When the location found
         * @param {Object} addressData Data of the found location
         * @param {Object} placeResultData PlaceResult object
         * @param {String} id Input container ID
         */
        getAddressData: function (addressData, placeResultData, id) {
            //console.log("addressData: ", addressData)
            //console.log("placeResultData: ", placeResultData)
            let district = addressData.administrative_area_level_2.split(" ")[0];
            //encode district name for bangle district name because of bangle district name is not working without encode
            let encodedDistrict = encodeURIComponent(district);
            let districtDetails = this.allDistrictList.filter((item) => {
                //this regex is for Cox's because ' this character is not working without regex
                let regex = new RegExp(`^${district.replace(/'/g, "['’]")}\\b`, "i");
                return item.name.bn === decodeURIComponent(encodedDistrict) || regex.test(item.name.en)
            })

            if (id === "pickup") {
                this.form.pickup_full_address = placeResultData.name +
                    (addressData?.route ? ", " + addressData.route : "") +
                    (addressData?.locality ? ", " + addressData.locality : "");
                this.pickup_district = district;

                this.form.pickup_district_id = districtDetails[0].id;
                this.form.pickup_division = addressData.administrative_area_level_1.split(" ")[0]
                this.isPickupSelected = true;
                this.error.pickup = false;
                this.startLocation = {
                    lat: placeResultData.geometry.location.lat(),
                    lng: placeResultData.geometry.location.lng()
                };
                this.form.pickup_lat = placeResultData.geometry.location.lat();
                this.form.pickup_long = placeResultData.geometry.location.lng();
            }
            if (id === "destination") {
                this.form.destination_full_address = placeResultData.name +
                    (addressData?.route ? ", " + addressData.route : "") +
                    (addressData?.locality ? ", " + addressData.locality : "");
                this.destination_district = district;

                this.form.destination_district_id = districtDetails[0].id;
                this.form.destination_division = addressData.administrative_area_level_1.split(" ")[0]
                this.isDestinationSelected = true;
                this.error.destination = false;
                this.endLocation = {
                    lat: placeResultData.geometry.location.lat(),
                    lng: placeResultData.geometry.location.lng()
                };
                this.form.destination_lat = placeResultData.geometry.location.lat();
                this.form.destination_long = placeResultData.geometry.location.lng();
            }

            if (id === "via") {
                this.form.via_full_address = placeResultData.name +
                    (addressData?.route ? ", " + addressData.route : "") +
                    (addressData?.locality ? ", " + addressData.locality : "");

                this.viaLocation = {
                    lat: placeResultData.geometry.location.lat(),
                    lng: placeResultData.geometry.location.lng()
                };
                this.form.via_lat = placeResultData.geometry.location.lat();
                this.form.via_long = placeResultData.geometry.location.lng();
                this.isViaSelected = true;
            }

            this.calculateDistance();
        },
        async districtList() {
            let district = await fetchDistrictWithoutDivision();
            this.allDistrictList = district.data;
        },

        //calculate distance between two location using lat and lng
        calculateDistance() {
            if (this.startLocation && this.endLocation) {
                const proxyUrl = 'map/directions';
                const params = {
                    origin: this.startLocation,
                    destination: this.endLocation
                };

                if (this.viaLocation) {
                    params.via = this.viaLocation;
                }

                axios.get(proxyUrl, {params})
                    .then(response => {
                        if (response.data.status === 'OK' && response.data.routes.length > 0) {
                            //this.form.distance = response.data.routes[0].legs[0].distance.value; // Distance meters
                            //this.form.duration = response.data.routes[0].legs[0].duration.value; // Duration in second


                            const route = response.data.routes[0];
                            let totalDistance = 0;
                            let totalDuration = 0;

                            route.legs.forEach(leg => {
                                totalDistance += leg.distance.value;
                                totalDuration += leg.duration.value;
                            });

                            if (this.form.type === 'round') {
                                totalDistance *= 2;
                            }

                            this.form.distance = totalDistance; // Distance in meters
                            this.form.duration = totalDuration; // Duration in seconds
                            console.log("Distance: ", this.form.distance);
                            console.log("Duration: ", this.form.duration);
                        } else {
                            this.distance = 'Unable to calculate distance.';
                        }

                    })
                    .catch(error => {
                        console.error('Error calculating distance:', error);
                        this.distance = 'Error calculating distance.';
                    });
            }
        },

        clearInput(id) {
            if (id === "pickup") {
                this.form.pickup_full_address = "";
                this.isPickupSelected = false;
                this.$refs.address.clear();
            }
            if (id === "destination") {
                this.form.destination_full_address = "";
                this.isDestinationSelected = false;
                this.$refs.address1.clear();
            }
            if (id === "via") {
                this.form.via_full_address = "";
                this.isViaSelected = false;
                this.$refs.address3.clear();
            }
        },

        getDistrictId(name) {
            let encodedDistrict = encodeURIComponent(name);
            let districtDetails = this.allDistrictList.filter((item) => {
                //this regex is for Cox's because ' this character is not working without regex
                let regex = new RegExp(`^${name.replace(/'/g, "['’]")}\\b`, "i");
                return item.name.bn === decodeURIComponent(encodedDistrict) || regex.test(item.name.en)
            })
            return districtDetails[0].id
        },

        checkTripDateValid() {
            if (this.selectedTrip) {
                let today = moment().format('DD-MM-YYYY')
                const format = "DD-MM-YYYY";
                let tripDate = moment(this.selectedTrip.journey_date, format)
                const formatedToday = moment(today, format)
                if (tripDate.isAfter(formatedToday)) {
                    return true;
                } else {
                    return false;
                }
            }
        },

        requestRepeat() {
            if (this.selectedTrip) {
                setTimeout(
                    function () {
                        const pickup = document.getElementById("pickup");
                        if (pickup) {
                            pickup.value = this.selectedTrip.pickup_full_address;
                            this.form.pickup_full_address = this.selectedTrip.pickup_full_address
                            this.form.pickup_division = this.selectedTrip.pickup_division
                        }

                        const destination = document.getElementById("destination");
                        if (destination) {
                            destination.value = this.selectedTrip.destination_full_address;
                            this.form.destination_full_address = this.selectedTrip.destination_full_address
                            this.form.destination_division = this.selectedTrip.destination_division
                        }

                        const j_date = document.getElementById("journey_date")
                        if (j_date && this.checkTripDateValid()) {
                            this.form.journey_date = this.selectedTrip.journey_date
                        }
                        const j_time = document.getElementById("journey_time")
                        if (j_time && this.checkTripDateValid()) {
                            this.form.journey_time = this.format24Hour(this.selectedTrip.journey_time)
                        }
                        const r_date = document.getElementById("return_date")
                        if (r_date && this.checkTripDateValid()) {
                            this.form.return_date = this.selectedTrip.return_date
                        }
                        const r_time = document.getElementById("return_time")
                        if (r_time && this.checkTripDateValid()) {
                            this.form.return_time = this.format24Hour(this.selectedTrip.return_time);
                        }
                        this.form.pickup_district_id = this.selectedTrip.geo_location.pickup_district_id
                        this.form.destination_district_id = this.selectedTrip.geo_location.destination_district_id
                    }.bind(this),
                    500
                );
                this.form.type = this.selectedTrip.type
                this.form.car_type = this.selectedTrip.car_type
                this.form.trip_note = this.selectedTrip.trip_note
                this.isPickupSelected = this.selectedTrip.geo_location.pickup_district_id ? true : false
                this.isDestinationSelected = this.selectedTrip.geo_location.destination_district_id ? true : false
                this.startLocation = {
                    lat: this.selectedTrip.pickup_lat,
                    lng: this.selectedTrip.pickup_long
                }
                this.endLocation = {
                    lat: this.selectedTrip.destination_lat,
                    lng: this.selectedTrip.destination_long
                }
                this.form.pickup_lat = this.selectedTrip.pickup_lat
                this.form.pickup_long = this.selectedTrip.pickup_long
                this.form.destination_lat = this.selectedTrip.destination_lat
                this.form.destination_long = this.selectedTrip.destination_long
                if (this.startLocation && this.endLocation) {
                    this.calculateDistance()
                }
            }
        },

        deleteTrip() {
            this.dform.action = this.userType;
            this.dform
                .post(`/trip/status/${this.selectedTrip.id}`, {
                    status: "canceled",
                    cancel_note: 'request again',
                    _method: "put",
                })
                .then((response) => {
                    if (response.success) {
                        this.updateTripListAfterCancel(this.selectedTrip);
                    }
                    this.setToaster(response.message);
                });
        },
        getEstimatedPrice(){
            let additionalCharge = 0;
            let distanceInKM = this.form.distance / 1000;
            // Exceptional District for 2k
            const exceptionalDistrict = [
                'e59a76ce-6147-429f-9c71-22800295b8b4',
                'efb03d46-3f2b-4d97-b9f1-9dcd2f2d3a90',
                'f37ffeba-9a3f-4e22-b7ef-ef0762274cd8',
                '549c72c5-9d16-460c-abf6-fcd4b241811b',
                '106f6825-27c1-4248-805d-39e13dbe6e56',
                'cbc4ed16-2c04-46ce-9827-56326c072f9e', // Narail District ID
                '0e6ead46-f901-4e55-b490-55f45abc2899' //Faridpur District ID (for sandbox)
            ];

            if (exceptionalDistrict.includes(this.form.pickup_district_id) || exceptionalDistrict.includes(this.form.destination_district_id)) {
                additionalCharge = 2000;
            }

            // Exceptional District for 1k
            const exceptionalDistrictFor1k = [
                'e5506272-8ff2-4e17-a9e0-c0a44c843435', // Sirajganj District ID
                'b571003c-9e33-429a-af81-7575f53a3b7b', // Pabna District ID
                '4588e75c-872a-4115-b4bf-f86e333f916b' // Sirajganj District ID (for sandbox)
            ];

            if (exceptionalDistrictFor1k.includes(this.form.pickup_district_id) || exceptionalDistrictFor1k.includes(this.form.destination_district_id)) {
                additionalCharge = 1000;
            }

            if (distanceInKM < 60) {
                this.minPrice = distanceInKM * 35;
                this.maxPrice = distanceInKM * 50;
                this.isPriceRangeValid = true;
                if (this.minPrice < 500) {
                    this.minPrice = 500;
                }
                if (this.maxPrice < 500) {
                    this.maxPrice = 750;
                }
            }
            if (distanceInKM >= 60 && distanceInKM <= 120) {
                this.minPrice = distanceInKM * 25;
                this.maxPrice = (distanceInKM * 35) + additionalCharge;
                this.isPriceRangeValid = true;
            }
            if (distanceInKM > 120 && distanceInKM <= 220) {
                this.minPrice = distanceInKM * 22;
                this.maxPrice = (distanceInKM * 32) + additionalCharge;
                this.isPriceRangeValid = true;
            }
            if (distanceInKM > 220) {
                this.minPrice = distanceInKM * 20;
                this.maxPrice = (distanceInKM * 30) + additionalCharge;
                this.isPriceRangeValid = true;
            }
        }
    },
    async mounted() {
        await this.districtList();
        await this.fetchCar();
        await this.requestRepeat()
        await this.setDeviceType()
    },
    watch: {
        cars: function () {
            this.getCarInfo()
        }
    }
};
</script>

<style lang="scss" scoped>
.pac-container .pac-item .pac-item-query .pac-matched {
    color: black !important;
}

.input-wrapper {
    position: relative;
}

.input-wrapper .remove {
    position: absolute;
    top: 60%;
    right: 10px;
    transform: translateY(-50%);
    cursor: pointer;
}

.input-container {
    max-width: 500px;
    min-width: 360px;
    margin: auto;
}

.width-set {
    max-width: 500px;
    min-width: 360px;
    margin: auto;
}

.did-floating-label-content {
    position: relative;
    margin-bottom: 5px;
}

.did-floating-label {
    color: #1e4c82;
    font-size: 14px;
    font-weight: normal;
    position: absolute;
    pointer-events: none;
    left: 35px;
    top: 15px;
    padding: 0 5px;
    background: #fff;
    transition: 0.2s ease all;
    -moz-transition: 0.2s ease all;
    -webkit-transition: 0.2s ease all;
}

.did-floating-input, .did-floating-select {
    font-size: 14px;
    display: block;
    width: 100%;
    height: 40px;
    padding: 0 10px;
    background: #fff;
    color: #323840;
    border: 1px solid #E0E5F4;
    border-radius: 4px;
    box-sizing: border-box;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.06);

    &:focus {
        outline: none;

        ~ .did-floating-label {
            top: -8px;
            left: 10px;
            font-size: 14px;
        }
    }
}

select.did-floating-select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
}

select.did-floating-select::-ms-expand {
    display: none;
}

.did-floating-input:not(:placeholder-shown) ~ .did-floating-label {
    top: -8px;
    left: 10px;
    font-size: 14px;
}

.did-floating-select:not([value=""]):valid ~ .did-floating-label {
    top: -8px;
    left: 10px;
    font-size: 14px;
}

.did-floating-select[value=""]:focus ~ .did-floating-label {
    top: 16px;
    left: 10px;
    font-size: 14px;
}

.did-floating-select:not([multiple]):not([size]) {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='6' viewBox='0 0 8 6'%3E%3Cpath id='Path_1' data-name='Path 1' d='M371,294l4,6,4-6Z' transform='translate(-371 -294)' fill='%23003d71'/%3E%3C/svg%3E%0A");
    background-position: right 15px top 50%;
    background-repeat: no-repeat;
}

.did-error-input {
    .did-floating-input, .did-floating-select {
        border: 2px solid #9d3b3b;
        color: #9d3b3b;
    }

    .did-floating-label {
        font-weight: 600;
        color: #9d3b3b;
    }

    .did-floating-select:not([multiple]):not([size]) {
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='6' viewBox='0 0 8 6'%3E%3Cpath id='Path_1' data-name='Path 1' d='M371,294l4,6,4-6Z' transform='translate(-371 -294)' fill='%239d3b3b'/%3E%3C/svg%3E%0A");
    }
}

.input-group {
    display: flex;

    .did-floating-input {
        border-radius: 0 8px 8px 0;
        border-left: 0;
        padding-left: 0;
    }
}

.input-group-append {
    display: flex;
    align-items: center;
}

.input-group-text {
    display: flex;
    align-items: center;
    font-weight: 400;
    height: 50px;
    color: #323840;
    padding: 0 5px 0 20px;
    font-size: 14px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #3D85D8;
    border-radius: 8px 0 0 8px;
    border-right: none;
}

svg.active {
    stroke: red;
}

.errorClass {
    border: 1px solid #D71920;
}

.trip-type {
    @apply px-4 rounded flex justify-between items-center cursor-pointer h-9;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.05);
    .svg {
        height: 16px;
        width: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        border: 1px solid #9D9D9D;

        path {
            fill: white;
        }
    }

    &.active {
        border: 1px solid #D71920;
        background: linear-gradient(0deg, rgba(255, 0, 0, 0.05) 0%, rgba(255, 0, 0, 0.05) 100%), #FFF;
        .svg {
            border: 1px solid #D72028;
            background: #D72028;
            path {
                fill: white;
            }
        }

        p {
            color: #D72028;
        }

        svg {
            path {
                fill: #D72028;
            }
        }
    }
}

.car-select {
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.05);

    .select-arrow {
        background: #D72028;
        height: 52px;
        width: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
}

.car-lists {
    .car-single {
        background: #FFFFFF;
        border-radius: 4px;
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.05);
        cursor: pointer;
        border: 1px solid #E0E5F4;

        &.active {
            background: rgba(215, 25, 32, 0.05);
            border: 1px solid #D72028;
            .check-select {
                background: #D72028;
            }
        }
        .car-image {
            height: 48px;
            width: 84px;
        }
        .car-info {
            padding: 10px 10px;
            margin-top: 5px;
        }

        .check-select {
            height: 52px;
            width: 40px;
            background: #BBC6D0;
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}

.trip-note-text-area {
    background: rgba(119, 129, 138, 0.05);
    resize: none;
    text-align: center;
    --textarea-height: 80px;
    height: var(--textarea-height);
    padding: calc(var(--textarea-height) / 4) 50px;
    overflow: hidden;
    box-sizing: border-box;
    font-size: 14px;

    &:focus {
        outline: none;
    }
}

.date-select {
    .date-icon {
        background: #BBC6D0;
        height: 36px;
        width: 36px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .select-arrow {
        background: #D72028;
        height: 52px;
        width: 40px;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
}

.trip-create-button {
    background: #D72028;
    color: #fff;
    font-weight: 700;
}

.trip-note {
    background: rgba(119, 129, 138, 0.05);
    text-align: center;
}

@media (max-width: 400px) {
    .trip-type {
        padding: 6px;

        .svg {
            height: 30px;
            width: 24px;
        }
    }

    .trip-note-text-area {

        --textarea-height: 80px;
        height: var(--textarea-height);
        padding: calc(var(--textarea-height) / 4) 30px;
    }
}

.confirm-information-trip {
    height: calc(100vh - 100px);
    background: #FFF;
}

.estimated-time-distance {
    border-radius: 10px;
    background: rgba(187, 198, 208, 0.20);
    padding: 10px;
}

.border-set {
    border: 1px solid #E0E5F4;
    background-color: #FFF;
    border-radius: 4px;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.06);
}

.ok-button {
    background-color: #D71920;
    color: #FFF;
    border-radius: 8px;
    padding: 8px 16px;
    cursor: pointer;
    box-shadow: 0 2px 24px 0 rgba(215, 25, 32, 0.30);
    p {
        font-family: 'Noto Sans Bengali', sans-serif;
        font-size: 16px;
        font-weight: 700;
    }
}

.cancel-button {
    color: #D71920;
    border-radius: 8px;
    padding: 8px 16px;
    cursor: pointer;
    border: 1px solid #D71920;
    p {
        font-family: 'Noto Sans Bengali', sans-serif;
        font-size: 16px;
        font-weight: 700;
    }
}
</style>